<template>
  <v-container grid-list-md class="pa-0 ma-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs v-model="tab"
        flat color="primary" dark
        grow height="40"
        fixed-tabs @change="refreshData()"
        >
        <v-tab v-for="(tabItem, n) in tabItems" :key="n" :href="`#tab-${n}`">
          <v-badge overlap>
            <template v-slot:badge v-if="enabledFilter['tab-' + n]">
              <v-icon class="caption">filter_list</v-icon>
            </template>
            <div class="pa-2">{{ tabItem + ' (' + totalTaskList[tabItem] + ')' }}</div>
          </v-badge>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-if="lAction === 'view-task'" v-model="tab" @change="refreshData()">
        <v-tab-item v-for="(tabItem, n) in tabItems" :key="n" :value="`tab-${n}`">
          <v-layout class="pa-0" row wrap>
            <v-flex xs12>
              <v-card-actions :class="totalTaskList[tabItem] === 0 ? '' : 'pa-1'">
                <div v-if="totalTaskList[tabItem] === 0 && !load" class="info--text text-xs-center pt-2">No Tasks!</div>
                <div class="px-2 py-0" v-if="tab === 'tab-0' && totalTaskList[tabItem] > 0">
                  <span v-for="(curFilter, n) in filterList" :key="n">
                    <v-chip v-if="filterStats.length > 0" @click="loadOpenTasks(curFilter)" :style="choosenFilter === curFilter ? { backgroundColor: '#4DA6A1', color: 'white' } : {}">{{ curFilter + ' (' + filterStats.filter(rec => rec.stats === curFilter)[0].total + ')' }}</v-chip>
                  </span>
                </div>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-flex>
            <!-- card view -->
            <v-flex xs12 sm7 mx-auto v-if="choosenView === 'card'">
              <v-card flat>
                <v-expansion-panel class="px-2" v-if="totalTaskList[tabItem] > 0" :value="selTab" popout>
                  <v-expansion-panel-content class="align-baseline my-2"
                  v-for="(taskTitle, i) in (tab === 'tab-0' ? subOpenTabItems : subClosedTabItems)" :key="i">
                  <div slot="header" class="px-0">
                    <div class="title" v-if="tasktabItems[taskTitle]">{{ taskTitle + ' (' + tasktabItems[taskTitle].length + ')' }}</div>
                  </div>
                  <v-card flat>
                    <v-card-text class="pt-0">
                      <v-data-iterator
                      :items="tasktabItems[taskTitle]"
                      hide-actions>
                      <template v-slot:item="props">
                        <v-layout>
                          <v-flex xs12 class="pb-2">
                            <v-card :id="'task_' + props.item.task_id">
                              <v-card-text class="py-0">
                                <v-layout row wrap>
                                  <v-flex xs10 sm11 class="pa-0">
                                    <div v-if="props.item.task_cat !== 'Project'" class="pt-3 subheading">
                                      <b>{{ props.item.task_cat + ' - ' +  props.item.service }}<span v-if="props.item.task_loc_id"> - {{props.item.task_loc}}</span></b> <span class="caption grey--text">{{'#' + props.item.task_id }}</span>
                                    </div>
                                    <div v-else class="pt-3 subheading">
                                      <b>{{ props.item.task_cat + ' - ' +  props.item.proj_name }}<span v-if="props.item.task_loc_id"> - {{props.item.task_loc}}</span></b> <span class="caption grey--text">{{'#' + props.item.task_id }}</span>
                                    </div>
                                  </v-flex>
                                  <v-flex xs2 sm1 class="pa-0">
                                    <v-menu
                                    :close-on-content-click="false"
                                    top right class="mt-0">
                                    <span slot="activator">
                                      <v-btn icon slot="activator">
                                        <v-icon>more_vert</v-icon>
                                      </v-btn>
                                    </span>
                                    <!-- list of menuitems -->
                                    <v-list class="py-0">
                                      <!-- menu with submenus of status -->
                                      <v-list-group
                                      no-action
                                      v-model="lTask.task_status"
                                      >
                                      <template v-slot:activator>
                                        <v-list-tile>
                                          <v-list-tile-avatar><v-icon>track_changes</v-icon></v-list-tile-avatar>
                                          <v-list-tile-title>Change Status</v-list-tile-title>
                                        </v-list-tile>
                                      </template>
                                      <v-list-tile
                                      v-if="props.item.task_status !== status"
                                      v-for="(status, i) in taskStatus"
                                      :key="i"
                                      @click="prepareTaskStatus(props.item, status)"
                                      >
                                      <v-list-tile-title>
                                        {{ status }}
                                      </v-list-tile-title>
                                    </v-list-tile>
                                  </v-list-group>
                                  <v-list-tile v-if="props.item.task_status !== 'Completed'" @click="prepareTaskStatus(props.item, 'Assigned')">
                                    <v-list-tile-avatar><v-icon>assignment_ind</v-icon></v-list-tile-avatar>
                                    <v-list-tile-title>Assign to</v-list-tile-title>
                                  </v-list-tile>
                                  <v-list-tile v-if="props.item.task_status !== 'Completed'" @click="prepareTaskStatus(props.item, 'Pending approval')">
                                    <v-list-tile-avatar><v-icon>assignment_ind</v-icon></v-list-tile-avatar>
                                    <v-list-tile-title>Request for approval</v-list-tile-title>
                                  </v-list-tile>
                                  <v-divider></v-divider>
                                  <v-list-tile v-if="props.item.task_status !== 'Completed'" @click="prepareTaskStatus(props.item, 'Commented')">
                                    <v-list-tile-avatar><v-icon>comment</v-icon></v-list-tile-avatar>
                                    <v-list-tile-title>Comment</v-list-tile-title>
                                  </v-list-tile>
                                  <v-list-tile v-if="props.item.task_status !== 'Completed'" @click="prepareUpdate(props.item)">
                                    <v-list-tile-avatar><v-icon>edit</v-icon></v-list-tile-avatar>
                                    <v-list-tile-title>Update</v-list-tile-title>
                                  </v-list-tile>
                                  <v-list-tile @click="prepareChecklist(props.item)">
                                    <v-list-tile-avatar><v-icon>check_box</v-icon></v-list-tile-avatar>
                                    <v-list-tile-title>Checklist</v-list-tile-title>
                                  </v-list-tile>
                                  <v-divider v-if="props.item.task_status !== 'Completed'"></v-divider>
                                  <v-list-tile @click="loadTimeLine(props.item.task_id)">
                                    <v-list-tile-avatar><v-icon>timeline</v-icon></v-list-tile-avatar>
                                    <v-list-tile-title>Timeline</v-list-tile-title>
                                  </v-list-tile>
                                </v-list>
                              </v-menu>
                            </v-flex>
                            <v-flex xs12>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <div class="pb-2">{{ props.item.task_desc }}</div>
                                  <v-divider></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                  <v-layout row wrap>
                                    <v-flex xs6>
                                      <v-layout row wrap>
                                        <v-flex xs3 sm2>
                                          <v-avatar size="24px" slot="activator" class="pt-0">
                                            <img :src="config.STATIC_FILES_DIR + props.item.created_avatar_url"/>
                                          </v-avatar>
                                        </v-flex>
                                        <v-flex xs9 sm10 class="caption">
                                          <div class="primary--text">Created by</div>
                                          <div>{{ props.item.created_by }}</div>
                                          <div>{{ handy.formatDate(props.item.task_timestamp) + ' ' + handy.getTime12Hrs(props.item.task_timestamp) }}</div>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6>
                                      <v-layout row wrap>
                                        <v-flex xs3 sm2>
                                          <v-avatar size="24px" slot="activator" class="pt-0">
                                            <img v-if="props.item.assigned_to" :src="config.STATIC_FILES_DIR + props.item.assigned_to_avatar_url"/>
                                            <v-icon class="grey" v-else>person</v-icon>
                                          </v-avatar>
                                        </v-flex>
                                        <v-flex xs9 sm10 class="caption">
                                          <div class="primary--text">Assigned to</div>
                                          <div v-if="props.item.assigned_to">
                                            <div>{{ props.item.assigned_to }}</div>
                                            <div v-if="props.item.assigned_dt">{{ handy.formatDate(props.item.assigned_dt) + ' ' + handy.getTime12Hrs(props.item.assigned_dt) }}</div>
                                          </div>
                                          <div v-else>NA</div>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12>
                                  <v-divider></v-divider>
                                  <v-layout row wrap :class="!props.item.tot_files ? 'py-2' : 'pt-2'">
                                    <v-flex xs4 sm6 class="subheading py-0">
                                      <div :class="props.item.task_status === 'New' ? 'grey--text' : (props.item.task_status === 'In Progress' ? 'accent--text' : (props.item.task_status === 'Completed' ? 'success--text' : 'error--text'))">
                                        {{ props.item.task_status }}
                                      </div>
                                      <div class="px-0 py-0" v-if="props.item.assigned_user_id === config.USER_ID && props.item.task_status !== 'Approved' && props.item.task_status === 'Pending approval' && !props.item.is_assigned_to_sv_user">
                                        <v-btn small @click="prepareTaskStatus(props.item, 'Approved')">Approve</v-btn>
                                      </div>
                                    </v-flex>
                                    <v-flex xs5 sm4 :class="props.item.task_status === 'Completed' ? 'pt-0' : 'py-0'">
                                      <div :class="tab === 'tab-0' ? (handy.formatDBDate(props.item.plan_end) === today ? 'orange--text' : (handy.formatDBDate(props.item.plan_end) < today ? 'error--text' : '')) : ''">{{ 'Due: ' + (props.item.plan_end ? handy.formatDate(props.item.plan_end) : 'NA') }}</div>
                                      <div v-if="props.item.task_status === 'Completed'">{{ 'End: ' + handy.formatDate(props.item.act_end) + ' ' + handy.getTime12Hrs(props.item.act_end) }}</div>
                                    </v-flex>
                                    <v-flex xs1 class="px-0 pb-0" @click="prepareChecklist(props.item)">
                                      <v-badge overlap color="info" v-if="props.item.tot_cl">
                                        <template v-slot:badge>
                                          <span class="caption">{{ props.item.tot_completed_cl + '/' + props.item.tot_cl }}</span>
                                        </template>
                                        <v-icon small class="pa-2">check_box</v-icon>
                                      </v-badge>
                                    </v-flex>
                                    <v-flex xs1 class="px-2 pb-0 " v-if="props.item.tot_files" @click="loadTimeLine(props.item.task_id)">
                                      <v-badge overlap color="info">
                                        <template v-slot:badge>
                                          <span class="caption">{{ props.item.tot_files }}</span>
                                        </template>
                                        <v-icon small class="pa-2">attach_file</v-icon>
                                      </v-badge>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </template>
              </v-data-iterator>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <infinite-loading v-if="tabItem === 'all closed'" @infinite="loadMoreClosed" spinner="spiral">
        <span slot="spinner"></span> <!-- no default spinner -->
        <span slot="no-more"></span> <!-- no default message -->
      </infinite-loading>
    </v-card>
  </v-flex>

  <!-- List view -->
  <v-flex xs12 v-if="choosenView === 'list' && totalTaskList[tabItem] > 0">
    <v-card flat>
      <v-card-text class="pt-0">
        <v-data-table
        :headers="$vuetify.breakpoint.smAndUp?listViewHeadersm:listViewHeader"
        :items="tab === 'tab-0' ? openTaskList['Past due'].concat(openTaskList['Due sooner']).concat(openTaskList['Due later']) : closedTaskList['All closed']"
        :rows-per-page-items = "[10,25,50,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
        :pagination.sync="rowsPerPage"
        disable-initial-sort
        class="elevation-1">
        <template slot="items" slot-scope="props">
          <tr>
            <td class="pa-2" v-if="$vuetify.breakpoint.smAndUp">{{ props.item.task_id }}</td>
            <td class="pa-2" v-if="props.item.task_cat !== 'Project' && $vuetify.breakpoint.smAndUp">{{ props.item.task_cat + ' - ' +  props.item.service }}</td>
            <td class="pa-2" v-if="props.item.task_cat === 'Project' && $vuetify.breakpoint.smAndUp">{{ props.item.task_cat + ' - ' +  props.item.proj_name }}</td>
            <td class="pa-2">{{ props.item.task_desc }}</td>
            <td class="pa-2" v-if="$vuetify.breakpoint.smAndUp">{{ (props.item.created_by ? props.item.created_by + ' ' : '') + (props.item.task_timestamp ? handy.formatDate(props.item.task_timestamp) + ' ' + handy.getTime12Hrs(props.item.task_timestamp) : '') }}</td>
            <td class="pa-2" v-if="$vuetify.breakpoint.smAndUp">{{ (props.item.assigned_to ? props.item.assigned_to + ' - ' : '') + (props.item.assigned_dt ? handy.formatDate(props.item.assigned_dt) + ' ' + handy.getTime12Hrs(props.item.assigned_dt) : '') }}</td>
            <td :class="'pa-2 ' + (tab === 'tab-0' ? (handy.formatDBDate(props.item.plan_end) === today ? 'warning lighten-2' : (handy.formatDBDate(props.item.plan_end) < today ? 'error lighten-2' : '')) : '')">{{ props.item.plan_end ? handy.formatDate(props.item.plan_end) : 'NA' }}</td>
            <td :class="'pa-2 ' + (props.item.task_status === 'New' ? 'grey--text' : (props.item.task_status === 'In Progress' ? 'accent--text' : (props.item.task_status === 'Completed' ? 'success--text' : 'error--text')))">{{ props.item.task_status }}</td>
            <td class="pa-2"><v-menu
              :close-on-content-click="false"
              top right class="mt-0">
              <span slot="activator">
                <v-btn icon slot="activator">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </span>
              <!-- list of menuitems -->
              <v-list class="py-0">
                <!-- menu with submenus of status -->
                <v-list-group
                no-action
                v-model="lTask.task_status"
                >
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-avatar><v-icon>track_changes</v-icon></v-list-tile-avatar>
                    <v-list-tile-title>Change Status</v-list-tile-title>
                  </v-list-tile>
                </template>
                <v-list-tile
                v-if="props.item.task_status !== status"
                v-for="(status, i) in taskStatus"
                :key="i"
                @click="prepareTaskStatus(props.item, status)">
                <v-list-tile-title>
                  {{ status }}
                </v-list-tile-title>
              </v-list-tile>
            </v-list-group>
            <v-list-tile v-if="props.item.task_status !== 'Completed'" @click="prepareTaskStatus(props.item, 'Assigned')">
              <v-list-tile-avatar><v-icon>assignment_ind</v-icon></v-list-tile-avatar>
              <v-list-tile-title>Assign to</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="props.item.task_status !== 'Completed'" @click="prepareTaskStatus(props.item, 'Pending approval')">
              <v-list-tile-avatar><v-icon>assignment_ind</v-icon></v-list-tile-avatar>
              <v-list-tile-title>Request for approval</v-list-tile-title>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile v-if="props.item.task_status !== 'Completed'" @click="prepareTaskStatus(props.item, 'Commented')">
              <v-list-tile-avatar><v-icon>comment</v-icon></v-list-tile-avatar>
              <v-list-tile-title>Comment</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="props.item.task_status !== 'Completed'" @click="prepareUpdate(props.item)">
              <v-list-tile-avatar><v-icon>edit</v-icon></v-list-tile-avatar>
              <v-list-tile-title>Update</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="prepareChecklist(props.item)">
              <v-list-tile-avatar><v-icon>check_box</v-icon></v-list-tile-avatar>
              <v-list-tile-title>Checklist</v-list-tile-title>
            </v-list-tile>
            <v-divider v-if="props.item.task_status !== 'Completed'"></v-divider>
            <v-list-tile @click="loadTimeLine(props.item.task_id)">
              <v-list-tile-avatar><v-icon>timeline</v-icon></v-list-tile-avatar>
              <v-list-tile-title>Timeline</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </td>
    </tr>
  </template>
</v-data-table>
</v-card-text>
</v-card>
</v-flex>

<!-- Calendar view -->
<v-flex xs12 :class="tab === 'tab-0' ? 'pb-0 pt-2' : 'pt-4 pb-0'" v-if="choosenView === 'calendar' && totalTaskList[tabItem] > 0">
  <v-flex xs12 class="pt-0">
    <v-layout row wrap>
      <v-flex xs2 class="text-xs-left">
        <v-btn fab outline small color="info" @click="prevMonth(n)">
          <v-icon dark>keyboard_arrow_left</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs8 class="text-xs-center">
        <span class="info--text title">{{calViewTitle}}</span>
        <div class="info--text" v-if="tab === 'tab-0'">{{totPlanedTask}} planned in this month.
          <span v-if="totUnplanedTask > 0" class="warning--text"> {{totUnplanedTask}} unplanned.</span>
        </div>
        <div class="info--text" v-else>
          {{totClosedTask}} closed in this month.
        </div>
      </v-flex>
      <v-flex xs2 class="text-xs-right">
        <v-btn fab outline small color="info" @click="nextMonth(n)">
          <v-icon dark>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
  <v-divider></v-divider>
  <v-sheet height="500">
    <v-calendar
    ref="calendar"
    v-model="start"
    :now="today"
    :value="today"
    :weekdays="[1, 2, 3, 4, 5, 6, 0]"
    color="primary">
    <template v-slot:day="{ date }">
      <template v-for="event in eventsMap[date]">
        <v-menu :close-on-content-click="false" :key="event.task_id" offset-x>
          <template v-slot:activator="{ on }">
            <div
            v-ripple v-on="on" style=" margin: 0px 1px 2px 1px; border-radius: 4px;"
            :class="tab === 'tab-0' ? (event.plan_end === today ? 'warning lighten-2 px-1 my-2' : (event.plan_end < today ? 'error lighten-2 px-1' : (event.plan_end > today ? 'success px-1 lighten-2' : ''))) : 'success lighten-2'"
            v-html="$vuetify.breakpoint.smAndUp ? event.task_desc.substring(0,40) : event.task_desc.substring(0,5)">
          </div>
        </template>
        <v-card :width="$vuetify.breakpoint.smAndUp ? '500px' : ''">
          <v-card-title class="py-0 primary white--text">
            <v-flex xs10 sm11 class="pa-0">
              <div class="pt-1 lighten-1 accent--text caption font-weight-bold">
                {{ event.comm_name }}
              </div>
              <div v-if="event.task_cat !== 'Project'" class="py-1 title">
                {{ event.task_cat + ' - ' +  event.service }} <span class="caption">{{'(Task #' + event.task_id + ')'}}</span>
              </div>
              <div v-else class="pt-1 subheading">
                {{ event.task_cat + ' - ' +  event.proj_name }} <span class="caption">{{'(Task #' + event.task_id + ')'}}</span>
              </div>
            </v-flex>
            <v-flex xs2 sm1 class="pa-0">
              <v-menu
              :close-on-content-click="false"
              top right class="mt-0">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon color="white">more_vert</v-icon>
                </v-btn>
              </template>
              <!-- list of menuitems -->
              <v-list class="py-0">
                <!-- menu with submenus of status -->
                <v-list-group
                no-action
                v-model="lTask.task_status"
                >
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-avatar><v-icon>track_changes</v-icon></v-list-tile-avatar>
                    <v-list-tile-title>Change Status</v-list-tile-title>
                  </v-list-tile>
                </template>
                <v-list-tile
                v-if="event.task_status !== status"
                v-for="(status, i) in taskStatus"
                :key="i"
                @click="prepareTaskStatus(event, status)"
                >
                <v-list-tile-title>
                  {{ status }}
                </v-list-tile-title>
              </v-list-tile>
            </v-list-group>
            <v-list-tile v-if="event.task_status !== 'Completed'" @click="prepareTaskStatus(event, 'Assigned')">
              <v-list-tile-avatar><v-icon>assignment_ind</v-icon></v-list-tile-avatar>
              <v-list-tile-title>Assign to</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="event.task_status !== 'Completed'" @click="prepareTaskStatus(event, 'Pending approval')">
              <v-list-tile-avatar><v-icon>assignment_ind</v-icon></v-list-tile-avatar>
              <v-list-tile-title>Request for approval</v-list-tile-title>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile v-if="event.task_status !== 'Completed'" @click="prepareTaskStatus(event, 'Commented')">
              <v-list-tile-avatar><v-icon>comment</v-icon></v-list-tile-avatar>
              <v-list-tile-title>Comment</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="event.task_status !== 'Completed'" @click="prepareUpdate(event)">
              <v-list-tile-avatar><v-icon>edit</v-icon></v-list-tile-avatar>
              <v-list-tile-title>Update</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="prepareChecklist(event)">
              <v-list-tile-avatar><v-icon>check_box</v-icon></v-list-tile-avatar>
              <v-list-tile-title>Checklist</v-list-tile-title>
            </v-list-tile>
            <v-divider v-if="event.task_status !== 'Completed'"></v-divider>
            <v-list-tile @click="loadTimeLine(event.task_id)">
              <v-list-tile-avatar><v-icon>timeline</v-icon></v-list-tile-avatar>
              <v-list-tile-title>Timeline</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
    </v-card-title>
    <v-card-text class="py-0 black--text">
      <v-flex xs12>
        <v-flex xs12 class="pt-0">
          <div class="pa-2">{{ event.task_desc }}</div>
          <v-divider></v-divider>
        </v-flex>
        <v-flex xs12 class="py-2">
          <v-layout>
            <v-flex xs6>
              <v-layout>
                <v-flex xs3 sm2>
                  <v-avatar size="24px" slot="activator" class="pt-0">
                    <img :src="config.STATIC_FILES_DIR + event.created_avatar_url"/>
                  </v-avatar>
                </v-flex>
                <v-flex xs9 sm10 class="caption">
                  <div class="primary--text">Created by</div>
                  <div>{{ event.created_by }}</div>
                  <div>{{ handy.formatDate(event.task_timestamp) + ' ' + handy.getTime12Hrs(event.task_timestamp) }}</div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-layout>
                <v-flex xs3 sm2>
                  <v-avatar size="24px" slot="activator" class="pt-0">
                    <img v-if="event.assigned_to" :src="config.STATIC_FILES_DIR + event.assigned_to_avatar_url"/>
                    <v-icon class="grey" v-else>person</v-icon>
                  </v-avatar>
                </v-flex>
                <v-flex xs9 sm10 class="caption">
                  <div class="primary--text">Assigned to</div>
                  <div v-if="event.assigned_to">
                    <div>{{ event.assigned_to }}</div>
                    <div v-if="event.assigned_dt">{{ handy.formatDate(event.assigned_dt) + ' ' + handy.getTime12Hrs(event.assigned_dt) }}</div>
                  </div>
                  <div v-else>NA</div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-divider></v-divider>
        <v-flex xs12 class="pt-1">
          <v-layout :class="!event.tot_files ? 'py-2' : 'pt-2'">
            <v-flex xs4 sm5 class="subheading py-0">
              <div :class="event.task_status === 'New' ? 'grey--text' : (event.task_status === 'In Progress' ? 'accent--text' : (event.task_status === 'Completed' ? 'success--text' : 'error--text'))">
                {{ event.task_status }}
              </div>
              <div class="px-0 py-0" v-if="event.assigned_user_id === config.SV_USER_ID && event.is_assigned_to_sv_user && event.task_status !== 'Approved' && event.task_status === 'Pending approval'">
                <v-btn small @click="prepareTaskStatus(event, 'Approved')">Approve</v-btn>
              </div>
            </v-flex>
            <v-flex xs4 sm5 :class="event.task_status === 'Completed' ? 'pt-0' : 'py-0'">
              <div :class="tab === 'tab-0' ? (handy.formatDBDate(event.plan_end) === today ? 'orange--text' : (handy.formatDBDate(event.plan_end) < today ? 'error--text' : '')) : ''">{{ 'Due: ' + (event.plan_end ? handy.formatDate(event.plan_end) : 'NA') }}</div>
              <div v-if="event.task_status === 'Completed'">{{ 'End: ' + handy.formatDate(event.act_end) + ' ' + handy.getTime12Hrs(event.act_end) }}</div>
            </v-flex>
            <v-flex xs1 class="px-0 pb-0 text-xs-left">
              <v-badge overlap color="info" v-if="event.tot_cl">
                <template v-slot:badge>
                  <span class="caption">{{ event.tot_completed_cl + '/' + event.tot_cl }}</span>
                </template>
                <v-icon small class="pa-2">check_box</v-icon>
              </v-badge>
            </v-flex>
            <v-flex xs1 class="px-0 pb-0 text-xs-right" v-if="event.tot_files">
              <v-badge overlap color="info">
                <template v-slot:badge>
                  <span class="caption">{{ event.tot_files }}</span>
                </template>
                <v-icon small class="pa-2">attach_file</v-icon>
              </v-badge>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-card-text>
  </v-card>
</v-menu>
</template>
</template>
</v-calendar>
</v-sheet>
</v-flex>
</v-layout>
</v-tab-item>

<v-speed-dial :direction="$vuetify.breakpoint.smAndDown ? 'bottom' : 'left'" v-model="calFab"
style="position:fixed; top:90px; right:10px;">
<v-btn small slot="activator" v-model="calFab" fab color="accent">
  <v-icon>remove_red_eye</v-icon>
  <v-icon>close</v-icon>
</v-btn>
<!-- card view -->
<v-tooltip top>
  <template v-slot:activator="{ on }">
    <v-btn class="mr-1" fab small v-on="on"
    :color="choosenView === 'card' ? 'info' : ''"
    @click.native="changeView('card')">
    <v-icon>filter_frames</v-icon>
  </v-btn>
</template>
<span>Card view</span>
</v-tooltip>
<!-- List view -->
<v-tooltip top>
  <template v-slot:activator="{ on }">
    <v-btn class="ma-1" fab small v-on="on"
    :color="choosenView === 'list' ? 'info' : ''"
    @click.native="changeView('list')">
    <v-icon>list</v-icon>
  </v-btn>
</template>
<span>List view</span>
</v-tooltip>
<!-- date view -->
<v-tooltip top>
  <template v-slot:activator="{ on }">
    <v-btn fab small v-on="on"
    :color="choosenView === 'calendar' ? 'info' : ''"
    @click.native="changeView('calendar')">
    <v-icon>date_range</v-icon>
  </v-btn>
</template>
<span>Calendar view</span>
</v-tooltip>
</v-speed-dial>

<!-- bucket btn -->
<v-tooltip top>
  <template v-slot:activator="{ on }">
    <v-btn small dark fab fixed v-if="lAction === 'view-task'" v-on="on"
    :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:15px;':'bottom:15px; left:315px;')"
    @click.native="prepareBucket" color="accent">
    <v-icon>storage</v-icon>
  </v-btn>
</template>
<span>Upload tasks from bucket</span>
</v-tooltip>

<!-- upload btn -->
<v-tooltip top>
  <template v-slot:activator="{ on }">
    <v-btn small dark fab fixed v-if="lAction === 'view-task'"
    :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:65px;':'bottom:15px; left:365px;')"
    @click.native="prepareUpload" v-on="on" color="accent">
    <v-icon>file_upload</v-icon>
  </v-btn>
</template>
<span>Upload task from csv</span>
</v-tooltip>

<!-- filter btn -->
<v-btn small v-if="lAction === 'view-task'"
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:115px;':'bottom:15px; left:415px;')"
dark fab fixed
color="accent"
@click.native="prepareFilter()">
<v-badge overlap color="info">
  <template v-slot:badge v-if="enabledFilter[this.tab]">
    <v-icon class="caption">done</v-icon>
  </template>
  <v-icon class="pa-2">filter_list</v-icon>
</v-badge>
</v-btn>

<!-- plus btn -->
<v-tooltip top>
  <template v-slot:activator="{ on }">
    <v-btn dark fab fixed v-if="lAction === 'view-task'" v-on="on"
    :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
    color="accent"
    @click.native="prepareCreate()">
    <v-icon small>add</v-icon>
  </v-btn>
</template>
<span class="caption">Create task</span>
</v-tooltip>
</v-tabs-items>
</v-flex>

<!-- 1. create / edit task -->
<v-container v-if="lAction === 'create-task' || lAction === 'update-task'" class="pa-2" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="lForm" @submit.prevent="saveChanges(lAction)">
        <v-card flat>
          <v-flex xs12 sm6 mx-auto>
            <v-card-text class="px-2 pb-2 pt-0">
              <v-container class="pa-0" grid-list-md>
                <v-layout row wrap>
                  <v-flex xs10 sm5>
                    <v-select
                    v-model="lTask.task_cat_pair"
                    :items="catList"
                    label="Task Category"
                    item-text="task_cat"
                    item-value="task_cat_id"
                    return-object
                    hide-details
                    @input="findCat(lTask)"
                    :rules="[rules.required]"
                    ></v-select>
                  </v-flex>
                  <v-flex xs2 sm1>
                    <v-btn icon class="grey lighten-2 mt-2" @click="prepareCategory"><v-icon>add</v-icon></v-btn>
                  </v-flex>
                  <v-flex xs12 sm12 v-if="lTask.task_cat === 'Project'">
                    <v-text-field
                    v-model="lTask.proj_name"
                    label="Project name"
                    :rules="[rules.required]"
                    maxlength="25"
                    hide-details
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs10 sm5 v-else>
                    <v-select
                    v-model="lTask.task_service"
                    :items="cats"
                    label="Service"
                    item-text="comp_cat"
                    :rules="[rules.required]"
                    hide-details
                    return-object
                    ></v-select>
                  </v-flex>
                  <v-flex xs2 sm1 v-if="lTask.task_cat !== 'Project'">
                    <v-btn icon class="grey lighten-2 mt-2" :to="{path: '/compset'}" ><v-icon>add</v-icon></v-btn>
                  </v-flex>
                  <v-flex xs10 sm11>
                    <v-select
                    v-model="lTask.task_loc_pair"
                    :items="locList"
                    label="Location (optional)"
                    item-text="task_loc"
                    item-value="task_loc_id"
                    hide-details
                    return-object
                    clearable
                    ></v-select>
                  </v-flex>
                  <v-flex xs2 sm1>
                    <v-btn icon class="grey lighten-2 mt-2" @click="prepareLoc"><v-icon>add</v-icon></v-btn>
                  </v-flex>
                  <v-flex xs12 class="pt-2">
                    <v-textarea
                    v-model="lTask.task_desc"
                    label="Task description"
                    rows="2"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="250"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs6 class="pt-2">
                    <v-dialog ref="planStartDt"
                    persistent v-model="planStartDt"
                    lazy max-width="290px"
                    :return-value.sync="lTask.plan_start"
                    >
                    <v-text-field
                    slot="activator" label="Plan start date"
                    v-model="lTask.plan_start"
                    append-icon="event"
                    readonly clearable
                    hide-details
                    required
                    ></v-text-field>
                    <v-date-picker v-model="lTask.plan_start" scrollable
                    first-day-of-week="1"
                    >
                    <v-spacer></v-spacer>
                    <v-btn flat @click="planStartDt = false">Cancel</v-btn>
                    <v-btn flat color="accent" @click="$refs.planStartDt.save(lTask.plan_start)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs6 class="pt-2">
                <v-dialog ref="planEndDt"
                persistent v-model="planEndDt"
                lazy max-width="290px"
                :return-value.sync="lTask.plan_end"
                >
                <v-text-field
                slot="activator" label="Plan end date"
                v-model="lTask.plan_end"
                append-icon="event"
                readonly clearable
                hide-details
                required
                ></v-text-field>
                <v-date-picker v-model="lTask.plan_end" scrollable
                :min="lTask.plan_start" first-day-of-week="1"
                >
                <v-spacer></v-spacer>
                <v-btn flat @click="planEndDt = false">Cancel</v-btn>
                <v-btn flat color="accent" @click="$refs.planEndDt.save(lTask.plan_end)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs12 sm6 class="pt-2">
            <v-select
            v-model="lTask.assigned_user_pair"
            :items="mcList"
            label="Assigned to"
            item-text="user_name"
            return-object
            hide-details
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 class="pt-2">
            <v-select
            v-model="lTask.priority"
            :items="['High', 'Normal', 'Low']"
            label="Priority"
            hide-details
            ></v-select>
          </v-flex>
          <v-flex xs12 v-if="lAction === 'update-task'">
            <v-layout row wrap>
              <v-flex xs6>
                <v-dialog ref="dlgStartDate"
                persistent v-model="dlgStartDate"
                lazy max-width="290px"
                :return-value.sync="lTask.act_start"
                >
                <v-text-field
                slot="activator" label="Actual start date"
                v-model="lTask.act_start"
                append-icon="event"
                readonly clearable
                hide-details
                required
                ></v-text-field>
                <v-date-picker v-model="lTask.act_start" scrollable
                :min="lTask.plan_start" first-day-of-week="1"
                >
                <v-spacer></v-spacer>
                <v-btn flat @click="dlgStartDate = false">Cancel</v-btn>
                <v-btn flat color="accent" @click="$refs.dlgStartDate.save(lTask.act_start)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6>
            <v-dialog ref="dlgEndDate"
            persistent v-model="dlgEndDate"
            lazy max-width="290px"
            :return-value.sync="lTask.act_end"
            >
            <v-text-field
            slot="activator" label="Actual end date"
            v-model="lTask.act_end"
            append-icon="event"
            readonly clearable
            hide-details
            required
            ></v-text-field>
            <v-date-picker v-model="lTask.act_end" scrollable
            :max="today" first-day-of-week="1"
            >
            <v-spacer></v-spacer>
            <v-btn flat @click="dlgEndDate = false">Cancel</v-btn>
            <v-btn flat color="accent" @click="$refs.dlgEndDate.save(lTask.act_end)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs6>
        <v-select
        v-model="lTask.task_status"
        :items="taskStatus"
        label="Task Status"
        hide-details
        ></v-select>
      </v-flex>
    </v-layout>
  </v-flex>
  <v-flex xs12>
    <input style="display:none" type="file" ref="fileInput"
    accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser(lTask)"/>
    <v-btn icon @click="pickFile"><v-icon>attach_file</v-icon></v-btn>
    <span v-if="lTask.files && lTask.files.filter(rec => rec.is_selected).length > 0">
      <span v-for="(file, index) in lTask.files.filter(rec => rec.is_selected)" :key="index">
        <v-chip v-model="file.is_selected" @input="$forceUpdate()" close>{{ file.file_name }}</v-chip>
      </span>
    </span>
    <span v-else class="caption">Attachment if any (upto 20MB)</span>
  </v-flex>
</v-layout>
</v-container>
</v-card-text>
<v-card-actions class="pt-3">
  <v-layout row wrap>
    <v-spacer></v-spacer>
    <v-btn @click.stop="cancelChanges">Cancel</v-btn>
    <v-btn v-if="lAction === 'update-task' && lTask.created_user_id === config.USER_ID && !lTask.is_created_by_sv_user" @click="deleteTask(lTask)">delete</v-btn>
    <v-btn type="submit" color="accent" :disabled="beingSaved">Submit</v-btn>
  </v-layout>
</v-card-actions>
</v-flex>
</v-card>
</v-form>
</v-flex>
</v-layout>
</v-container>

<!-- 2. Give notes based on your actions(comment, need more info., on-hold, completed) -->
<v-dialog v-model="showDlgStatus" persistent max-width="500px">
  <v-card>
    <v-card-title class="py-3 title grey lighten-4" v-if="lTaskStatus.task_action === 'Assigned' || lTaskStatus.task_action === 'Need More Info.' || lTaskStatus.task_action === 'Pending approval'">
      <div v-if="lTaskStatus.task_action === 'Assigned' || lTaskStatus.task_action === 'Need More Info.'">Assign to</div>
      <div v-if="lTaskStatus.task_action === 'Pending approval'">Request for approval</div>
    </v-card-title>
    <v-card-text class="pb-0">
      <v-layout row wrap>
        <v-flex xs12 v-if="lTaskStatus.task_action === 'Assigned' || lTaskStatus.task_action === 'Need More Info.' || lTaskStatus.task_action === 'Pending approval'">
          <v-select
          class="pt-0"
          v-model="lTaskStatus.assigned_user_pair"
          label="Assigned to"
          :items="mcList"
          item-text="user_name"
          return-object
          ></v-select>
        </v-flex>
        <v-flex xs12 v-if="lTaskStatus.task_action === 'Completed'">
          <v-layout row wrap>
            <v-flex xs8 sm5 class="pr-1">
              <v-dialog ref="dlgEndDate"
              persistent v-model="dlgEndDate"
              lazy max-width="290px"
              :return-value.sync="lTaskStatus.act_end"
              >
              <v-text-field
              slot="activator" label="Actual end date"
              v-model="lTaskStatus.act_end"
              append-icon="event"
              readonly clearable
              hide-details
              required
              ></v-text-field>
              <v-date-picker v-model="lTaskStatus.act_end" scrollable
              :max="today" first-day-of-week="1"
              >
              <v-spacer></v-spacer>
              <v-btn flat @click="dlgEndDate = false">Cancel</v-btn>
              <v-btn flat color="accent" @click="$refs.dlgEndDate.save(lTaskStatus.act_end)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs4 class="pl-1">
          <v-dialog
          ref="dlgEndTime"
          persistent
          v-model="dlgEndTime"
          lazy
          max-width="290px"
          :return-value.sync="lTaskStatus.endTime"
          >
          <v-text-field
          slot="activator"
          v-model="lTaskStatus.endTime"
          append-icon="access_time"
          clearable
          readonly
          ></v-text-field>
          <v-time-picker v-model="lTaskStatus.endTime">
            <v-spacer></v-spacer>
            <v-btn flat @click="dlgEndTime = false">Cancel</v-btn>
            <v-btn flat color="accent" @click="$refs.dlgEndTime.save(lTaskStatus.endTime)">OK</v-btn>
          </v-time-picker>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-flex>
  <v-flex xs12>
    <v-textarea hide-details outline
    :placeholder="placeHolder"
    maxlength="250"
    v-model="lTaskStatus.notes"></v-textarea>
  </v-flex>
  <v-flex xs12>
    <input style="display:none" type="file" ref="statusFileInput"
    accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser(lTaskStatus)"/>
    <v-btn icon @click="pickFile"><v-icon>attach_file</v-icon></v-btn>
    <span v-if="lTaskStatus.files && lTaskStatus.files.filter(rec => rec.is_selected).length > 0">
      <span v-for="(file, index) in lTaskStatus.files.filter(rec => rec.is_selected)" :key="index">
        <v-chip v-model="file.is_selected" @input="$forceUpdate()" close>{{ file.file_name }}</v-chip>
      </span>
    </span>
    <span v-else>Attachment if any<br /><span class="caption">(supports images, pdfs, docs and excels upto 20MB)</span></span>
  </v-flex>
</v-layout>
</v-card-text>
<v-card-actions class="px-0 pt-0">
  <v-spacer></v-spacer>
  <v-btn flat @click.stop="showDlgStatus = false">cancel</v-btn>
  <v-btn class="ma-0" flat color="accent" @click="postTaskStatus()">submit</v-btn>
</v-card-actions>
</v-card>
</v-dialog>

<!-- 3. show Timeline for particular task_id -->
<v-dialog v-model="showTimeline" scrollable max-width="600px">
  <v-card>
    <v-card-title class="py-1 title grey lighten-4">
      <div>Timeline</div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showTimeline = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-timeline dense class="pt-0">
        <v-timeline-item :class="n === lTimeLine.length-1 ? 'pb-0' : ''"
        v-for="(timeline, n) in lTimeLine"
        :key="n"
        small
        :id="'timeline_' + n"
        >
        <template v-slot:icon>
          <v-avatar>
            <img :src="config.STATIC_FILES_DIR + timeline.avatar_url">
          </v-avatar>
        </template>
        <v-card>
          <div v-if="timeline.task_action === 'Assigned' || timeline.task_action === 'Need More Info.'">
            <v-card-title class="title pa-2">
              {{ timeline.task_action }}
            </v-card-title>
            <v-card-text class="pt-0 pb-2">
              <div>{{ 'Assigned to: ' + timeline.assigned_to }}</div>
              <div>{{ timeline.notes }}</div>
            </v-card-text>
          </div>
          <div v-else>
            <v-card-title :class="timeline.task_action === 'Commented' && timeline.created_by_user_id === config.USER_ID && !lTask.is_created_by_sv_user && $vuetify.breakpoint.smAndUp ? 'title px-2 py-0' : 'title pa-2'">
              <div>{{ timeline.task_action }}</div>
              <v-spacer></v-spacer>
              <span class="text-xs-right" v-if="timeline.task_action === 'Commented' && timeline.created_by_user_id === config.USER_ID && !lTask.is_created_by_sv_user && !timeline.is_created_by_sv_user">
                <v-btn class="ma-0" icon @click="deleteComment(timeline)"><v-icon small>delete</v-icon></v-btn>
                <v-btn class="ma-0" icon @click="prepareUpdateComment(timeline)"><v-icon small>edit</v-icon></v-btn>
              </span>
            </v-card-title>
            <v-card-text :class="timeline.notes ? 'py-0' : 'pl-2 py-0 pr-0'">
              <div v-if="timeline.task_action === 'Pending approval'">{{ 'Request sent to: ' + timeline.assigned_to }}</div>
              <div v-if="timeline.task_action === 'Approved'">{{ 'Assigned back to: ' + timeline.assigned_to }}</div>
              <div v-if="timeline.notes !== ''">
                <div v-if="timeline.task_action === 'Task Updated'">
                  <div v-for="(note, i) in timeline.timeLineNote" :key="i">
                    <span v-if="note">{{ i+1 + '. ' + note }}</span>
                  </div>
                </div>
                <div v-else class="pb-1">
                  {{ timeline.notes }}
                </div>
              </div>
            </v-card-text>
          </div>
          <v-container grid-list-sm class="pa-0"
          v-if="lTimeLine.attachImages && lTimeLine.attachImages.filter(rec => rec.task_action === timeline.task_action && timeline.task_det_id === rec.task_det_id && handy.formatDateTime(rec.attach_timestamp) === handy.formatDateTime(timeline.action_dt)).length ||
          lTimeLine.attachFile && lTimeLine.attachFile.filter(rec => rec.task_action === timeline.task_action && timeline.task_det_id === rec.task_det_id && handy.formatDateTime(rec.attach_timestamp) === handy.formatDateTime(timeline.action_dt))">
          <v-flex xs12 class="pa-0">
            <v-layout row wrap>
              <v-flex xs12 sm6 class="text-xs-center" v-if="lTimeLine.attachImages.length && lTimeLine.attachImages.filter(rec => rec.task_action === timeline.task_action).length > 0">
                <v-flex xs12 v-if="(lTimeLine.attachImages.filter(rec => rec.task_action === timeline.task_action && rec.task_det_id === timeline.task_det_id).length > 0) && (lTimeLine.attachFile.filter(rec => rec.task_action === timeline.task_action && rec.task_det_id === timeline.task_det_id).length > 0)">
                  <v-layout row wrap class="caption grey--text mb-2">
                    <v-flex xs3 sm2>
                      <v-divider class="mt-2"></v-divider>
                    </v-flex>
                    <v-flex xs6 sm8>
                      Image Attachments
                    </v-flex>
                    <v-flex xs3 sm2>
                      <v-divider class="mt-2"></v-divider>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <div v-viewer="options" class="clearfix">
                    <template v-for="(file, index) in lTimeLine.attachImages">
                      <span v-if="(file.task_action === timeline.task_action && file.task_det_id === timeline.task_det_id)">
                        <img width="80px" :src="file.file_url" :data-source="file.file_url" :key="index" class="ma-1" style="display: inline-block; cursor: pointer;">
                      </span>
                    </template>
                  </div>
                </v-flex>
              </v-flex>
              <v-flex xs12 sm6 class="text-xs-center" v-if="lTimeLine.attachFile.length && lTimeLine.attachFile.filter(rec => rec.task_action === timeline.task_action).length > 0">
                <v-flex xs12 v-if="(lTimeLine.attachImages.filter(rec => rec.task_action === timeline.task_action && rec.task_det_id === timeline.task_det_id).length > 0) && (lTimeLine.attachFile.filter(rec => rec.task_action === timeline.task_action && rec.task_det_id === timeline.task_det_id).length > 0)">
                  <v-layout row wrap class="caption grey--text mb-2">
                    <v-flex xs3 sm2>
                      <v-divider class="mt-2"></v-divider>
                    </v-flex>
                    <v-flex xs6 sm8>
                      Other Attachments
                    </v-flex>
                    <v-flex xs3 sm2>
                      <v-divider class="mt-2"></v-divider>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <span v-for="(file, index) in lTimeLine.attachFile" :key="index" class="ma-1">
                    <v-chip v-if="(file.task_action === timeline.task_action && file.task_det_id === timeline.task_det_id)">
                      {{file.file_name}}
                      <a :href="file.file_url" download style="text-decoration: none;">
                        <v-btn small icon class="mr-0 grey lighten-1 grey--text text--lighten-4">
                          <v-icon small>file_download</v-icon>
                        </v-btn>
                      </a>
                    </v-chip>
                  </span>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions class="caption pa-2">
          {{ timeline.created_by }}
          <span class="grey--text pl-2">{{ handy.formatDate(timeline.action_dt) + ' ' + handy.getTime12Hrs(timeline.action_dt) }}</span>
        </v-card-actions>
      </v-card>
    </v-timeline-item>
  </v-timeline>
</v-card-text>
</v-card>
</v-dialog>

<!-- 4. show filter category in bottom sheet -->
<v-bottom-sheet inset class="caption" v-model="showFilter" max-width="500px">
  <v-card>
    <v-card-text>
      <v-container grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex xs12>
            <div class="caption primary--text">Filter by attributes</div>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filterListByTab[tab].task_cat_list"
            :items="catList"
            label="Category"
            item-text="task_cat"
            item-value="task_cat_id"
            hide-details
            small-chips
            clearable
            dense
            multiple
            return-object
            @input="filterTaskCatList(filterListByTab[tab])"
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filterListByTab[tab].task_service_list"
            :items="cats"
            label="Service"
            item-text="comp_cat"
            item-value="comp_cat_id"
            small-chips
            clearable
            dense
            multiple
            hide-details
            ></v-select>
          </v-flex>
          <v-flex xs12 v-if="filterListByTab[tab].is_proj_cat">
            <v-select
            v-model="filterListByTab[tab].proj_name_list"
            :items="projName.filter(rec => rec !== '')"
            label="Project"
            small-chips
            clearable
            dense
            multiple
            hide-details
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-select
            v-model="filterListByTab[tab].task_loc_list"
            :items="locList"
            label="Location"
            item-text="task_loc"
            item-value="task_loc_id"
            small-chips
            clearable
            dense
            multiple
            hide-details
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filterListByTab[tab].priority_list"
            label="Severity"
            :items="['High', 'Normal', 'Low']"
            small-chips
            clearable
            dense
            multiple
            hide-details
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filterListByTab[tab].task_status_list"
            label="Status"
            :items="filterStatus"
            small-chips
            clearable
            dense
            multiple
            hide-details
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <div class="caption primary--text pt-3">Filter by people</div>
          </v-flex>
          <v-flex xs12>
            <v-select
            v-model="filterListByTab[tab].created_user_pair_list"
            label="Created by"
            :items="mcList"
            item-text="user_name"
            dense
            hide-details
            return-object
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-select
            v-model="filterListByTab[tab].assigned_user_pair_list"
            :items="mcList"
            label="Assigned to"
            item-text="user_name"
            dense
            hide-details
            return-object
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <div class="caption primary--text pt-3">Filter by date</div>
          </v-flex>
          <v-flex xs6>
            <v-dialog ref="dlgFromDate"
            persistent v-model="dlgFromDate"
            lazy max-width="290px"
            :return-value.sync="filterListByTab[tab].from_dt"
            >
            <v-text-field
            slot="activator" label="Due from"
            v-model="filterListByTab[tab].from_dt"
            append-icon="event"
            readonly clearable
            hide-details
            required
            ></v-text-field>
            <v-date-picker v-model="filterListByTab[tab].from_dt" scrollable
            first-day-of-week="1"
            >
            <v-spacer></v-spacer>
            <v-btn flat @click="dlgFromDate = false">Cancel</v-btn>
            <v-btn flat color="accent" @click="$refs.dlgFromDate.save(filterListByTab[tab].from_dt)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs6>
        <v-dialog ref="dlgToDate"
        persistent v-model="dlgToDate"
        lazy max-width="290px"
        :return-value.sync="filterListByTab[tab].to_dt"
        >
        <v-text-field
        slot="activator" label="Due till"
        v-model="filterListByTab[tab].to_dt"
        append-icon="event"
        readonly clearable
        hide-details
        required
        ></v-text-field>
        <v-date-picker v-model="filterListByTab[tab].to_dt" scrollable
        first-day-of-week="1"
        >
        <v-spacer></v-spacer>
        <v-btn flat @click="dlgToDate = false">Cancel</v-btn>
        <v-btn flat color="accent" @click="$refs.dlgToDate.save(filterListByTab[tab].to_dt)">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </v-flex>
</v-layout>
</v-container>
</v-card-text>
<v-card-actions>
  <v-btn flat @click.stop="showFilter = false">Close</v-btn>
  <v-spacer></v-spacer>
  <v-btn flat @click="clearFilter">Clear all</v-btn>
  <v-btn class="ma-0" flat color="accent" @click="applyFilter">Apply</v-btn>
</v-card-actions>
</v-card>
</v-bottom-sheet>

<!-- 5. Upload Tasks -->
<v-container grid-list-md v-if="lAction === 'upload-task' || lAction === 'upload-bucket'" class="pa-0">
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pb-0">
          Upload {{ lAction === 'upload-bucket' ? 'Task Bucket' : 'Tasks' }}
        </v-card-title>
        <div class="mt-3 text-xs-center primary--text" style="font-family: 'Satisfy', cursive; font-size:200%; font-weight:normal">
          {{ lAction === 'upload-bucket' ? 'In just 5 steps' : 'In just 4 steps' }}
        </div>
        <v-card-text class="subheading">
          <v-layout row wrap>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 1</v-chip>
              <span>Download template</span>
              <span style="float:right;" v-if="lAction === 'upload-task'">
                <form method="get" action="../static/files/Smartility_Task_Template.xlsx">
                  <v-btn type="submit" class="mt-0 mb-0" small><v-icon>file_download</v-icon></v-btn>
                </form>
              </span>
              <span style="float:right;" v-else>
                <form method="get" action="../static/files/Smartility_Task_Bucket_Template.xlsx">
                  <v-btn type="submit" class="mt-0 mb-0" small><v-icon>file_download</v-icon></v-btn>
                </form>
              </span>
            </v-flex>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 2</v-chip>
              <span>Fill-in details as guided in template</span>
              <div class="caption grey--text pl-4 ml-4" v-if="lAction === 'upload-task'">
                <span class="ml-4">(Tip: <a style="text-decoration: underline;" @click="LoadAssignedUserDetails">Click here</a> to see the list of users that you can assign a task to)</span>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 3</v-chip>
              <span>Save as CSV <span class="caption">(Comma delimited)</span><br />
              <span class="caption grey--text pl-4 ml-4">
                <span class="ml-4">Go with OK/Yes when prompted while saving</span>
              </span>
            </span>
          </v-flex>
          <v-flex xs12 v-if="lAction === 'upload-bucket'">
            <v-layout row wrap>
              <v-flex xs12 md4>
                <v-chip small disabled outline class="primary--text">Step 4</v-chip>
                <span>Name your bucket</span>
                <div class="px-4">
                  <v-radio-group v-model="bucketType" :mandatory="false" hide-details>
                    <v-radio label="Create new bucket" value="new"></v-radio>
                    <v-radio label="Append into existing bucket" value="existing"></v-radio>
                  </v-radio-group>
                </div>
              </v-flex>
              <v-flex xs12 md4 v-if="bucketType === 'new'" :class="$vuetify.breakpoint.smAndUp ? 'pt-4 mt-3' : 'mb-2 px-5'">
                <v-text-field
                class="pt-0"
                v-model="lBucket.task_bucket_name"
                placeholder="Enter bucket name"
                hide-details
                maxlength="50"
                :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4 v-if="bucketType !== 'new'" :class="$vuetify.breakpoint.smAndUp ? 'pt-5 mt-4' : 'mb-2 px-5'">
                <v-select
                class="pt-0"
                v-model="lBucket.task_bucket_id"
                :items="bucketList"
                item-value="task_bucket_id"
                item-text="task_bucket_name"
                placeholder="Choose existing bucket"
                hide-details
                :rules="[rules.required]"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-chip small disabled outline class="primary--text">
              <span v-if="lAction === 'upload-bucket'">Step 5</span>
              <span v-else>Step 4</span>
            </v-chip>
            <span>Upload the CSV file</span>
            <span style="float:right;"><v-btn small class="mt-0 mb-0 accent" @click.native="promptUpload"><v-icon>file_upload</v-icon></v-btn></span>
            <input style="display:none" ref="ipFile" type="file" accept=".csv" @change="validateFile()"/>
          </v-flex>
          <v-flex xs12>
            <div class="mt-3 text-xs-center primary--text" style="font-family: 'Satisfy', cursive; font-size:200%; font-weight:normal">Integra takes care of rest</div>
          </v-flex>
          <v-flex xs12>
            <v-chip small disabled outline class="primary--text">
              <span v-if="lAction === 'upload-bucket'">Step 6</span>
              <span v-else>Step 5</span>
            </v-chip>
            <span>Validate your information</span>
          </v-flex>
          <v-flex xs12>
            <v-chip small disabled outline class="primary--text">
              <span v-if="lAction === 'upload-bucket'">Step 7</span>
              <span v-else>Step 6</span>
            </v-chip>
            <span v-if="lAction === 'upload-bucket'">Create task bucket</span>
            <span v-else>Create task records</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="pt-0 pr-4">
        <v-spacer></v-spacer>
        <v-btn @click.native="cancelChanges">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</v-layout>
</v-container>

<!-- 6. validate and upload -->
<v-container v-if="lAction === 'validate'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pb-0">
          {{ lBucket.task_bucket_name || lBucket.task_bucket_id ? 'Upload Task Bucket' : 'Upload Tasks' }}
        </v-card-title>
        <v-card-text class="text-xs-center pl-2 pr-2">
          <v-layout row wrap>
            <v-flex xs12 md9 mx-auto>
              <v-layout row wrap>
                <v-flex xs12 class="info--text mb-2">
                  <span v-if="validateInProgress">Loading and validating the file...</span>
                  <span v-if="validFile && !validateInProgress">File validation is successfull <v-icon class="success--text">check</v-icon></span>
                  <span v-if="!validFile">File validation is failed <v-icon class="error--text">close</v-icon></span>
                  <span v-if="!validFile && headerIssue" class="error--text"><br />Invalid column headers, please ensure names and count are matching as per the template</span>
                  <span v-if="!validFile && !headerIssue" class="error--text"><br />One or more invalid records, review the table below.<br/>Click on the errored row to know more info.</span>
                  <span v-if="!totFail && !loadInProgress">Tasks uploaded successfully<v-icon class="success--text">check</v-icon></span>
                  <span v-if="!totLoaded && totFail && !loadInProgress"><br />Tasks upload failed<v-icon class="error--text">close</v-icon></span>
                  <span v-if="totLoaded && totFail && !loadInProgress"><br />Tasks upload partially failed<v-icon class="warning--text">close</v-icon></span>
                  <span v-if="totFail && !loadInProgress" class="error--text"><br />One or more failed records, review the table below.<br/>Click on the errored row to know more info.</span>
                </v-flex>
                <v-flex xs4 v-if="totRecs">
                  <v-progress-circular color="info"
                  :value="readyForLoad ? 100 : (recsLoaded.length/totRecs*100)"
                  :size="50" :width="7">
                  {{ readyForLoad ? totValid : recsLoaded.length }}
                </v-progress-circular>
                <br/><div class="caption grey--text">Records</div>
              </v-flex>
              <v-flex xs4 v-if="totRecs">
                <v-progress-circular color="success"
                :value="(totValid/totRecs*100)"
                :size="50" :width="7">
                {{ readyForLoad ? totLoaded : totValid }}
              </v-progress-circular>
              <br/><div class="caption grey--text">{{ readyForLoad ? 'Loaded' : 'Valid' }}</div>
            </v-flex>
            <v-flex xs4 v-if="totRecs">
              <v-progress-circular color="error"
              :value="(totInvalid/totRecs*100)"
              :size="50" :width="7">
              {{ readyForLoad ? totFail : totInvalid }}
            </v-progress-circular>
            <br/><div class="caption grey--text">{{ readyForLoad ? 'Failed' : 'Invalid' }}</div>
          </v-flex>
          <v-flex xs12>
            <v-btn small @click.native="cancelValidation">Close</v-btn>
            <v-btn v-if="totValid > 0" small class="accent" @click.native="uploadTask" :disabled="beingSaved">Process the valid records</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 class="mt-2 pa-2">
        <v-data-table
        :headers="$vuetify.breakpoint.smAndUp && !lBucket.task_bucket_name && !lBucket.task_bucket_id ? loadHeadSm : ($vuetify.breakpoint.smAndUp && lBucket.task_bucket_name || lBucket.task_bucket_id ? loadBucketHead : loadHead)"
        :items="recsLoaded"
        hide-actions
        class="elevation-3 text-xs-left"
        disable-initial-sort
        >
        <template slot="items" slot-scope="props">
          <tr :class="(props.item.error ? (props.item.load_status === 'Failed' ? 'error':'error--text') : (props.item.load_status === 'Loaded' ? 'success' : ''))" @click="props.item.error ? showError(props.item.error) : ''">
            <td class="pa-2">{{ props.item.task_cat }}</td>
            <td class="pa-2" v-if="$vuetify.breakpoint.smAndUp">{{ props.item.service }}</td>
            <td class="pa-2" v-if="$vuetify.breakpoint.smAndUp">{{ props.item.proj_name }}</td>
            <td class="pa-2">{{ props.item.task_desc }}</td>
            <td class="pa-2" v-if="$vuetify.breakpoint.smAndUp && !lBucket.task_bucket_name && !lBucket.task_bucket_id">{{ props.item.check_list }}</td>
            <td class="pa-2" v-if="$vuetify.breakpoint.smAndUp && !lBucket.task_bucket_name && !lBucket.task_bucket_id">{{ props.item.plan_start }}</td>
            <td class="pa-2" v-if="$vuetify.breakpoint.smAndUp && !lBucket.task_bucket_name && !lBucket.task_bucket_id">{{ props.item.plan_end }}</td>
            <td class="pa-2" v-if="$vuetify.breakpoint.smAndUp && !lBucket.task_bucket_name && !lBucket.task_bucket_id">{{ props.item.assigned_to }}</td>
            <td class="pa-2" v-if="$vuetify.breakpoint.smAndUp && !lBucket.task_bucket_name && !lBucket.task_bucket_id">{{ props.item.priority}}</td>
            <td class="pa-2" v-if="$vuetify.breakpoint.smAndUp && !lBucket.task_bucket_name && !lBucket.task_bucket_id">{{ props.item.task_status }}</td>
            <td class="pa-2" v-if="$vuetify.breakpoint.smAndUp && !lBucket.task_bucket_name && !lBucket.task_bucket_id">{{ props.item.act_start}}</td>
            <td class="pa-2" v-if="$vuetify.breakpoint.smAndUp && !lBucket.task_bucket_name && !lBucket.task_bucket_id">{{ props.item.act_end }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</v-card-text>
<v-card-actions class="pt-0" v-if="false">
  <v-spacer></v-spacer>
  <v-btn flat @click.native="cancelChanges">Cancel</v-btn>
</v-card-actions>
</v-card>
</v-flex>
</v-layout>
</v-container>

<!-- 7. manage category -->
<v-dialog v-model="manageTaskCat" persistent max-width="400px">
  <v-form>
    <v-card flat v-if="lMAction === 'view'" scrollable>
      <v-card-title class="title grey lighten-4 py-0">
        Task Category
        <v-spacer></v-spacer>
        <v-btn small icon @click.stop="manageTaskCat = false"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-flex xs12 sm9 md12 class="mx-auto">
          <v-spacer></v-spacer>
          <v-btn color="accent" flat class="mb-0" style="float: right" @click="createManageTask">Add New</v-btn>
          <v-data-table
          :headers="ManageTaskHead"
          :items="catList"
          hide-actions
          disable-initial-sort
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <tr @click="prepareEdit(props.item)">
              <td>{{ props.item.task_cat }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>

  <!-- 8. create / edit Task Category -->
  <v-container v-if="lMAction === 'create' || lMAction === 'update'" class="pa-0" fluid grid-list-md>
    <v-form ref="acForm" @submit.prevent="saveTaskCat(lMAction)">
      <v-card flat class="pa-0">
        <v-card-title class="title pb-0">
          {{ handy.startWithUpper(lMAction) }} Task Category
        </v-card-title>
        <v-card-text>
          <v-text-field
          v-model="lCat.task_cat"
          label="Category name"
          :rules="[rules.required]"
          hide-details
          maxlength="25">
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click.stop="cancelChangesCat">Cancel</v-btn>
        <v-btn flat v-if="lMAction === 'update'" :disabled="beingSaved" @click="deleteCat(lCat)">Delete</v-btn>
        <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</v-container>
</v-form>
</v-dialog>

<!-- 7.1. manage locations -->
<v-dialog v-model="manageTaskLoc" persistent max-width="400px">
  <v-form>
    <v-card flat v-if="lLAction === 'view'" scrollable>
      <v-card-title class="title grey lighten-4 py-0">
        Task Location
        <v-spacer></v-spacer>
        <v-btn small icon @click.stop="manageTaskLoc = false"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-flex xs12 sm9 md12 class="mx-auto">
          <v-spacer></v-spacer>
          <v-btn color="accent" flat class="mb-0" style="float: right" @click="createManageLoc">Add New</v-btn>
          <v-data-table
          :headers="ManageLocHead"
          :items="locList"
          hide-actions
          disable-initial-sort
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <tr @click="prepareEditLoc(props.item)">
              <td>{{ props.item.task_loc }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>

  <!-- 8.1 create / edit Task Location -->
  <v-container v-if="lLAction === 'create' || lLAction === 'update'" class="pa-0" fluid grid-list-md>
    <v-form ref="acForm" @submit.prevent="saveTaskLoc(lLAction)">
      <v-card flat class="pa-0">
        <v-card-title class="title pb-0">
          {{ handy.startWithUpper(lLAction) }} Task Location
        </v-card-title>
        <v-card-text>
          <v-text-field
          v-model="lLoc.task_loc"
          label="Location name"
          :rules="[rules.required]"
          hide-details
          maxlength="25">
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click.stop="cancelChangesLoc">Cancel</v-btn>
        <v-btn flat v-if="lLAction === 'update'" :disabled="beingSaved" @click="deleteLoc(lLoc)">Delete</v-btn>
        <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</v-container>
</v-form>
</v-dialog>

<!-- 9. Task Bucket view -->
<v-container v-if="lAction === 'view-bucket'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12 md6 mx-auto>
      <v-card>
        <v-card-title class="title pb-0">Available Task Bucket</v-card-title>
        <v-card-text class="pb-0">
          <v-data-table
          :headers="bucketHeader"
          :items="bucketList"
          class="elevation-3"
          hide-actions>
          <template slot="items" slot-scope="props">
            <tr @click="prepareImportBucket(props.item)">
              <td>{{ props.item.task_bucket_name }}</td>
              <td>{{ props.item.tot_bucket_task }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click.native="cancelChanges">cancel</v-btn>
        <v-btn flat color="accent" @click.native="prepareUpload"><v-icon color="accent">file_upload</v-icon>Upload</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</v-layout>
</v-container>

<!-- 10. show the particular import screen where user can select and import it into task list -->
<v-dialog v-model="showImportBucketList" scrollable persistent width="900px">
  <v-card>
    <v-card-title class="grey lighten-4">
      <div class="title grey--text pa-1">{{ 'Bucket Name: ' + bucketImportList[0].task_bucket_name }}</div>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      v-model="selected"
      :headers="loadBucketImportHead"
      :items="bucketImportList"
      select-all hide-actions
      item-key="task_bucket_det_id"
      class="elevation-1"
      >
      <template v-slot:headers="props">
        <tr>
          <th>
            <v-checkbox :input-value="props.all"
            :indeterminate="props.indeterminate"
            primary hide-details
            @click.stop="toggleAll"></v-checkbox>
          </th>
          <th class="text-xs-left"
          v-for="header in props.headers"
          :key="header.text"
          >
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <tr :active="props.selected" @click="props.selected = !props.selected">
        <td>
          <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
        </td>
        <td>{{ props.item.task_cat }}</td>
        <td>{{ props.item.service }}</td>
        <td>{{ props.item.proj_name }}</td>
        <td>{{ props.item.task_desc }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon small class="mr-0"><v-icon small @click="prepareUpdateTaskInBucket(props.item)">edit</v-icon></v-btn>
          <v-btn icon small><v-icon small @click="deleteTaskInBucket(props.item)">delete</v-icon></v-btn>
        </td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn flat @click.stop="showImportBucketList = false">cancel</v-btn>
  <v-btn flat color="accent" @click="importToTask" :disabled="!selected.length">Import to task</v-btn>
</v-card-actions>
</v-card>
</v-dialog>

<!-- 11. Edit/ delete Bucket -->
<v-dialog v-model="showEditBucket" scrollable max-width="500px">
  <v-container class="pa-0" grid-list-md>
    <v-card>
      <v-card-title class="pa-2 grey lighten-4">
        <div class="title grey--text pa-1">Update Task</div>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-layout row wrap>
          <v-flex xs6>
            <v-select
            v-model="lImportList.task_cat_pair"
            :items="catList"
            label="Task Category"
            item-text="task_cat"
            item-value="task_cat_id"
            return-object
            hide-details
            @input="findCat(lImportList)"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm12 v-if="lImportList.task_cat === 'Project'">
            <v-text-field
            v-model="lImportList.proj_name"
            label="Project Name"
            :rules="[rules.required]"
            maxlength="25"
            hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 v-else>
            <v-select
            v-model="lImportList.task_service"
            :items="cats"
            label="Service"
            item-text="comp_cat"
            item-value="comp_cat_id"
            :rules="[rules.required]"
            hide-details
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-textarea
            v-model="lImportList.task_desc"
            label="Task description"
            rows="2"
            :rules="[rules.required]"
            hide-details
            maxlength="250"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="accent" @click.stop="showEditBucket = false">cancel</v-btn>
        <v-btn flat color="accent" @click="saveUpdatedTask">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</v-dialog>

<!-- 12. show assigned user details -->
<v-dialog v-model="showAssignedUser" scrollable persistent max-width="400px">
  <v-card>
    <v-card-title class="grey lighten-4 title">
      Eligible Assignees
      <v-spacer></v-spacer>
      <v-btn icon small @click.stop="showAssignedUser = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
      :headers="AssignedUserHeader"
      :items="mcList"
      hide-actions
      class="elevation-2"
      >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.user_id }}</td>
          <td>{{ props.item.user_name }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<!-- 13. show task checklist -->
<v-dialog v-model="showCheckList" scrollable persistent max-width="940px">
  <v-card>
    <v-card-title :class="$vuetify.breakpoint.smAndUp ? 'title py-0 grey lighten-4' : 'title pa-2 grey lighten-4'">
      {{ 'Checklist: ' + lCl.task_cat + ' - ' +  lCl.service }} <span class="caption grey--text">{{ '(Task #' + lCl.task_id + ')' }}</span>
      <v-spacer></v-spacer>
      <v-btn flat icon @click="showCheckList = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pt-0">
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs6 class="pt-2">
            <span class="subheading info--text" v-if="lCl.tot_cl">{{ lCl.tot_completed_cl + '/' + lCl.tot_cl }} completed</span>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <v-spacer></v-spacer>
            <v-btn flat small class="accent" :disabled="lCl.task_status === 'Completed'" @click="prepareCreateCl">Add Item</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-data-table
        :headers="$vuetify.breakpoint.smAndUp?clHeader:clHeaderSm"
        :items="clList"
        hide-actions
        disable-initial-sort
        class="tblChecklist elevation-1">
        <template slot="items" slot-scope="props">
          <tr>
            <td @click="dragElement()" class="handle"><v-icon>zoom_out_map</v-icon></td>
            <td class="pa-3"><v-checkbox hide-details :disabled="lCl.task_status === 'Completed' ? true : false" v-model="props.item.is_cl_completed" @change="saveTaskClChanges(props.item)"></v-checkbox></td>
            <td class="pa-3" :style="props.item.is_cl_completed ? 'text-decoration: line-through;' : ''">{{ props.item.cl_item }}</td>
            <td class="pa-3" v-if="$vuetify.breakpoint.smAndUp" :style="props.item.is_cl_completed ? 'text-decoration: line-through;' : ''">{{ props.item.cl_created_by + ' on ' + handy.formatDate(props.item.cl_created_on) + ' ' + handy.getTime12Hrs(props.item.cl_created_on) }}</td>
            <td class="pa-3" v-if="$vuetify.breakpoint.smAndUp" :style="props.item.is_cl_completed ? 'text-decoration: line-through;' : ''">{{ props.item.cl_last_updated_by ? props.item.cl_last_updated_by + ' on ' + handy.formatDate(props.item.cl_last_updated_on) + ' ' + handy.getTime12Hrs(props.item.cl_last_updated_on) : '-' }}</td>
            <td class="justify-center layout px-0 py-2">
              <v-btn icon small class="mr-0" :disabled="(lCl.task_status === 'Completed' ? true : props.item.is_cl_completed)"><v-icon small @click="prepareUpdateChecklist(props.item)">edit</v-icon></v-btn>
              <v-btn icon small :disabled="(lCl.task_status === 'Completed' ? true : props.item.is_cl_completed)"><v-icon small @click="deleteTaskChecklist(props.item)">delete</v-icon></v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-card-text>
  <v-card-actions class="grey lighten-4 caption">
    <v-flex xs12 class="text-xs-right">
      <v-download-as
      :headers="clDownloadHeader"
      :items="clDownloadList"
      title="Task checklist"
      ></v-download-as>
    </v-flex>
  </v-card-actions>
</v-card>
</v-dialog>

<!-- 14. create/update/delete checklist -->
<v-dialog v-model="showCl" scrollable persistent max-width="500px">
  <v-container grid-list-md class="pa-0">
    <v-form ref="clForm" @submit.prevent="saveClChanges">
      <v-card>
        <v-card-title class="title pb-0">
          {{ this.lChecklist.lAction === 'create' ? 'Create' : 'Update' }} checklist
        </v-card-title>
        <v-card-text class="pt-0">
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
              v-model="lChecklist.cl_item"
              label="Item"
              :rules="[rules.required]"
              maxlength="150"
              hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.stop="showCl = false">Cancel</v-btn>
          <v-btn flat type="submit" color="accent">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="2000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

<!-- add more data based on user scroll in closed task -->
<div v-if="load" class="text-xs-center mt-5">
  <v-progress-circular indeterminate color="primary"></v-progress-circular>
</div>

</v-layout>
</v-container>
</template>

<style>
.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}
</style>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'
import InfiniteLoading from 'vue-infinite-loading'
import Sortable from 'sortablejs'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
Vue.use(Viewer)

export default {
  props: ['action'],
  components: {
    'v-download-as': VDownloadAs,
    InfiniteLoading
  },
  data () {
    return {
      calFab: false,
      load: false,
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      lAction: '',
      tab: 'tab-0',
      recPerPage: 10,
      lastRec: [],
      handy: handy,
      rules: handy.rules,
      config: config,
      beingSaved: false,
      planEndDt: false,
      planStartDt: false,
      dlgStartDate: false,
      dlgEndDate: false,
      dlgEndTime: false,
      mcList: [],
      choosenFilter: '',
      tabItems: ['all open', 'all closed'],
      subOpenTabItems: ['Past due', 'Due sooner', 'Due later'],
      subClosedTabItems: ['All closed'],
      openTaskList: {'Past due': [], 'Due sooner': [], 'Due later': []},
      closedTaskList: ['All closed'],
      tasktabItems: [],
      selTab: 0,
      selId: '',
      filterList: ['Assigned To MC', 'Assigned To Me', 'Created By Me', 'All'],
      totalTaskList: {},
      lTask: [],
      cats: [],
      previousData: [],
      taskStatus: ['New', 'In Progress', 'Need More Info.', 'On-hold', 'Completed', 'Cancelled'],
      lTaskStatus: [],
      lTimeLine: {},
      showTimeline: false,
      showDlgStatus: false,
      placeHolder: '',
      showImage: false,
      imageUrl: '',
      filterStats: [],
      showFilter: false,
      filteredCats: [],
      projName: [],
      filterStatus: ['New', 'In Progress', 'Need More Info.', 'On-hold', 'Pending approval', 'Cancelled', 'Approved'],
      dlgFromDate: false,
      dlgToDate: false,
      taskItems: [],
      // file upload
      validateInProgress: true,
      readyForLoad: false,
      loadInProgress: true,
      validFile: true,
      headerIssue: false,
      fileError: false,
      totRecs: 0,
      recsLoaded: [],
      totValid: 0,
      totInvalid: 0,
      totLoaded: 0,
      totFail: 0,
      reqHeaders: ['Task Category', 'Service', 'Project name', 'Description', 'Checklist', 'Plan start date', 'Plan end date', 'Assigned to', 'Priority', 'Status', 'Actual start date', 'Actual end date'],
      reqHeadersBucket: ['Task Category', 'Service', 'Project name', 'Description'],
      colNames: [
        {col_name: 'task_cat', is_required: true},
        {col_name: 'service', is_required: true},
        {col_name: 'proj_name', is_required: true},
        {col_name: 'task_desc', is_required: true},
        {col_name: 'check_list', is_required: false},
        {col_name: 'plan_start', is_required: false},
        {col_name: 'plan_end', is_required: false},
        {col_name: 'assigned_to', is_required: false},
        {col_name: 'priority', is_required: false},
        {col_name: 'task_status', is_required: false},
        {col_name: 'act_start', is_required: false},
        {col_name: 'act_end', is_required: false}
      ],
      colNamesBucket: [
        {col_name: 'task_cat', is_required: true},
        {col_name: 'service', is_required: true},
        {col_name: 'proj_name', is_required: true},
        {col_name: 'task_desc', is_required: true}
      ],
      loadHead: [
        { text: 'Task Category', value: 'task_cat', class: 'pa-2' },
        { text: 'Description', value: 'task_desc', class: 'pa-2' }
      ],
      loadHeadSm: [
        { text: 'Task Category', value: 'task_cat', class: 'pa-2' },
        { text: 'Service', value: 'service', class: 'pa-2' },
        { text: 'Project name', value: 'proj_name', class: 'pa-2' },
        { text: 'Description', value: 'task_desc', class: 'pa-2' },
        { text: 'CheckList', value: 'check_list', class: 'pa-2' },
        { text: 'Plan start date', value: 'plan_start', class: 'pa-2' },
        { text: 'Plan end date', value: 'plan_end', class: 'pa-2' },
        { text: 'Assigned to', value: 'assigned_to', class: 'pa-2' },
        { text: 'Priority', value: 'priority', class: 'pa-2' },
        { text: 'Status', value: 'task_status', class: 'pa-2' },
        { text: 'Actual start date', value: 'act_start', class: 'pa-2' },
        { text: 'Actual end date', value: 'act_end', class: 'pa-2' }
      ],
      loadBucketHead: [
        { text: 'Task Category', value: 'task_cat', class: 'pa-2' },
        { text: 'Service', value: 'service', class: 'pa-2' },
        { text: 'Project name', value: 'proj_name', class: 'pa-2' },
        { text: 'Description', value: 'task_desc', class: 'pa-2' }
      ],
      loadBucketImportHead: [
        { text: 'Task Category', value: 'task_cat' },
        { text: 'Service', value: 'service' },
        { text: 'Project name', value: 'proj_name' },
        { text: 'Description', value: 'task_desc' },
        { text: 'Action', value: '' }
      ],
      manageTaskCat: false,
      lCat: {},
      lMAction: '',
      ManageTaskHead: [
        { text: 'Task category', value: 'task_cat' }
      ],
      catList: [],
      manageTaskLoc: false,
      lLoc: {},
      lLAction: '',
      ManageLocHead: [
        { text: 'Task location', value: 'task_loc' }
      ],
      locList: [],
      bucketHeader: [
        { text: 'Bucket Name', value: 'task_bucket_name' },
        { text: 'No. Of Tasks', value: 'tot_bucket_task' }
      ],
      bucketList: [],
      bucketType: 'new',
      lBucket: {},
      bucketImportList: [
        { task_bucket_name: '' }
      ],
      showImportBucketList: false,
      pagination: {
        sortBy: 'task_desc'
      },
      selected: [],
      lImportList: {},
      showEditBucket: false,
      showAssignedUser: false,
      AssignedUserHeader: [
        { text: 'User Id', value: 'user_id' },
        { text: 'User Name', value: 'user_name' }
      ],
      choosenView: 'card',
      listViewHeadersm: [
        { text: 'Task No.', value: 'task_id', class: 'pa-2' },
        { text: 'Category', value: 'task_cat', class: 'pa-2' },
        { text: 'Description', value: 'task_desc', class: 'pa-2' },
        { text: 'Created by', value: 'created_by', class: 'pa-2' },
        { text: 'Assigned to', value: 'assigned_to', class: 'pa-2' },
        { text: 'Due date', value: 'plan_end', class: 'pa-2' },
        { text: 'Status', value: 'task_status', class: 'pa-2' },
        { text: 'Menu', value: '', class: 'pa-2' }
      ],
      listViewHeader: [
        { text: 'Description', value: 'task_desc', class: 'pa-2' },
        { text: 'Due date', value: 'plan_end', class: 'pa-2' },
        { text: 'Status', value: 'task_status', class: 'pa-2' },
        { text: 'Menu', value: '', class: 'pa-2' }
      ],
      start: handy.formatDBDate(Date()),
      lCalendarViewList: [],
      totUnplanedTask: 0,
      totPlanedTask: 0,
      totClosedTask: 0,
      calViewPeriod: new Date(),
      calViewTitle: '',
      filterListByTab: [],
      enabledFilter: [],
      options: {
        toolbar: true,
        url: 'data-source'
      },
      rowsPerPage: { rowsPerPage: 25 },
      showCheckList: false,
      lCl: [],
      clHeader: [
        { text: '', value: '' },
        { text: 'Status', value: 'is_cl_completed', class: 'pa-3' },
        { text: 'Item', value: 'cl_item', class: 'pa-3', width: '250px' },
        { text: 'Created by', value: 'cl_created_by', class: 'pa-3' },
        { text: 'Last updated by', value: 'cl_last_updated_by', class: 'pa-3' },
        { text: 'Action', value: '', class: 'pa-3' }
      ],
      clHeaderSm: [
        { text: '', value: '' },
        { text: 'status', value: 'is_cl_completed', class: 'pa-3' },
        { text: 'Item', value: 'cl_item', class: 'pa-3' },
        { text: 'Action', value: '', class: 'pa-3' }
      ],
      clList: [],
      showCl: false,
      lChecklist: {},
      taskId: null,
      clDownloadList: [],
      clDownloadHeader: [
        { text: 'Item', value: 'cl_item' },
        { text: 'Status', value: 'status' }
      ]
    }
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    },
    eventsMap () {
      const map = {}
      if (this.tab === 'tab-0') {
        this.lCalendarViewList.forEach(e => (map[e.plan_end] = map[e.plan_end] || []).push(e))
      } else {
        this.lCalendarViewList.forEach(e => (map[e.act_end] = map[e.act_end] || []).push(e))
      }
      return map
    }
  },
  created () {
    for (var i = 0; i < this.tabItems.length; i++) {
      this.totalTaskList[this.tabItems[i]] = 0
      this.enabledFilter['tab-' + i] = false
      this.filterListByTab['tab-' + i] = this.getEmptyFilter()
    }
    for (i = 0; i < this.filterList.length; i++) {
      this.filterStats = []
    }
    this.closedTaskList['All closed'] = []
    this.loadTaskStats()
    this.loadTaskStatsByCommId()
    this.loadOpenTasks('Assigned To Me')
    this.tasktabItems = this.openTaskList
    this.loadAssignToList()
    this.loadTaskCategory()
    this.loadTaskLocation()
    // default title of calendar view
    this.calViewTitle = handy.getMonthName(this.calViewPeriod.getMonth()) + ' ' + this.calViewPeriod.getFullYear()
  },
  mounted () {
    this.dragElement()
    this.lAction = 'view-task'
  },
  methods: {
    dragElement () {
      let table = document.querySelector('.tblChecklist tbody')
      const self = this
      Sortable.create(table, {
        handle: '.handle',
        onEnd ({ newIndex, oldIndex }) {
          const rowSelected = self.clList.splice(oldIndex, 1)[0]
          self.clList.splice(newIndex, 0, rowSelected)
          self.clList[newIndex].cl_order = newIndex
          self.clList[newIndex].oldIndex = oldIndex
          self.saveChecklistIndex(self.clList[newIndex])
        }
      })
    },
    saveChecklistIndex (curCheckList) {
      this.axios.post(config.API_URL + '/taskChecklist/index', curCheckList)
      .then(response => {
        setTimeout(() => {
          this.loadCheckList(curCheckList.task_id)
        }, 1000)
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    filterTaskCatList (curList) {
      this.filterListByTab[this.tab].is_proj_cat = (this.filterListByTab[this.tab].task_cat_list.map(rec => rec.task_cat)).includes('Project')
      this.filterListByTab[this.tab].task_cat_id_list = this.filterListByTab[this.tab].task_cat_list.map(rec => rec.task_cat_id)
      this.$forceUpdate()
    },
    toggleAll () {
      if (this.selected.length) {
        this.selected = []
      } else {
        this.selected = this.bucketImportList.slice()
      }
    },
    refreshData () {
      this.tasktabItems = []
      if (this.tab === 'tab-0') {
        this.loadTaskStatsByCommId()
        this.loadOpenTasks(this.choosenFilter)
        this.closedTaskList['All closed'] = []
      } else {
        this.loadClosedTasks(true)
        this.tasktabItems = this.closedTaskList
        this.selTab = 0
      }
    },
    loadTaskStats () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getOpenClosedTaskStatsByCommOrVendor/', qry)
      .then(response => {
        this.totalTaskList['all open'] = response.data[0].tot
        this.totalTaskList['all closed'] = response.data[1].tot
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadServiceCat () {
      var qry = {
        params: {
          comm_id_list: config.COMM_ID
        }
      }
      // available categories
      this.axios.get(config.API_URL + '/getComplaintCotegories/', qry)
      .then(response => {
        this.cats = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.cats = []
      })
    },
    getEmptyTask () {
      var emptyTask = {
        comm_id: config.COMM_ID,
        created_user_id: config.USER_ID,
        is_created_by_sv_user: false,
        is_action_by_sv_user: false,
        assigned_user_pair: {
          user_id: null,
          user_name: '',
          is_sv_user: false
        },
        task_cat: '',
        task_cat_pair: '',
        task_service: {},
        task_desc: '',
        proj_name: '',
        plan_start: null,
        plan_end: null,
        priority: 'Normal',
        act_start: null,
        act_end: null,
        task_status: 'New',
        files: []
      }
      return emptyTask
    },
    prepareCreate () {
      this.lTask = this.getEmptyTask()
      this.lAction = 'create-task'
    },
    pickFile () {
      if (this.lAction === 'create-task' || this.lAction === 'update-task') {
        this.$refs.fileInput.click()
      } else {
        this.$refs.statusFileInput.click()
      }
    },
    loadFilesFromFileBrowser (curTask) {
      const files = event.target.files
      if (!curTask.files) {
        curTask.files = []
      }
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            curTask.files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name,
              is_selected: true,
              is_changed: true
            })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    },
    saveChanges (action) {
      if (action === 'create-task' || action === 'update-task') {
        if (this.$refs.lForm.validate()) {
          this.lTask.notes = ''
          if (action === 'update-task') {
            if (this.previousData.task_cat !== this.lTask.task_cat) {
              this.lTask.notes += ' Category to "' + this.lTask.task_cat + '",'
            }
            if (this.previousData.task_service.comp_cat_id !== this.lTask.task_service.comp_cat_id) {
              this.lTask.notes += ' Service to "' + this.lTask.task_service.comp_cat + '",'
            }
            if (this.previousData.proj_name !== this.lTask.proj_name) {
              this.lTask.notes += ' Project to "' + this.lTask.proj_name + '",'
            }
            if (this.previousData.task_desc !== this.lTask.task_desc) {
              this.lTask.notes += ' Desc to "' + this.lTask.task_desc + '",'
            }
            if (this.previousData.plan_start !== this.lTask.plan_start) {
              this.lTask.notes += ' Plan start date to "' + this.lTask.plan_start + '",'
            }
            if (this.previousData.plan_end !== this.lTask.plan_end) {
              this.lTask.notes += ' Plan end date to "' + this.lTask.plan_end + '",'
            }
            if (this.previousData.act_start && (this.previousData.act_start !== this.lTask.act_start)) {
              this.lTask.notes += ' Actual start to "' + this.lTask.act_start + '",'
            }
            if (this.previousData.act_end && (this.previousData.act_end !== this.lTask.act_end)) {
              this.lTask.notes += ' Actual end to "' + this.lTask.act_end + '",'
            }
            if (this.previousData.task_status !== this.lTask.task_status) {
              this.lTask.notes += ' Status to "' + this.lTask.task_status + '",'
            }
            if (this.previousData.priority !== this.lTask.priority) {
              this.lTask.notes += ' Priority to "' + this.lTask.priority + '",'
            }
            if (this.previousData.assigned_user_pair.user_id !== this.lTask.assigned_user_pair.user_id) {
              this.lTask.notes += ' Assigned to "' + this.lTask.assigned_user_pair.user_name + '"'
            }
          }
          if (!this.lTask.files) {
            this.lTask.files = []
          }
          if (this.lTask.task_cat === 'Project') {
            this.lTask.task_service = {}
          } else {
            this.lTask.proj_name = ''
          }
          if (this.lTask.assigned_user_pair.is_sv_user) {
            this.lTask.is_assigned_to_sv_user = true
          } else {
            this.lTask.is_assigned_to_sv_user = false
          }
          this.lTask.is_action_by_sv_user = false
          this.beingSaved = true
          this.axios.post(config.API_URL + '/task/' + action, this.lTask)
          .then(response => {
            this.loadTaskStatsByCommId()
            this.loadOpenTasks(this.choosenFilter)
            this.loadTaskStats()
            this.beingSaved = false
            this.lAction = 'view-task'
            this.tab = 'tab-0'
            this.$forceUpdate()
          })
          .catch(err => {
            this.msg(err, 0)
            this.beingSaved = false
          })
        }
      }
    },
    prepareUpdate (curTask) {
      this.lTask = Object.assign({}, curTask) // keep the original object safely before changes
      this.lTask.task_service = {comp_cat: curTask.service, comp_cat_id: curTask.task_service}
      this.lTask.plan_end = this.lTask.plan_end ? handy.formatDBDate(this.lTask.plan_end) : null
      this.lTask.plan_start = this.lTask.plan_start ? handy.formatDBDate(this.lTask.plan_start) : null
      this.lTask.act_start = this.lTask.act_start ? handy.formatDBDate(this.lTask.act_start) : null
      this.lTask.act_end = this.lTask.act_end ? handy.formatDBDate(this.lTask.act_end) : null
      this.lTask.action_by = config.USER_ID
      this.lTask.task_cat_pair = {task_cat: this.lTask.task_cat, task_cat_id: this.lTask.task_cat_id}
      this.lTask.task_loc_pair = {task_loc: this.lTask.task_loc, task_loc_id: this.lTask.task_loc_id}
      this.lTask.assigned_user_pair = {user_id: this.lTask.assigned_user_id, user_name: this.lTask.assigned_to, is_sv_user: this.lTask.is_assigned_to_sv_user}
      this.previousData = Object.assign({}, this.lTask) // if there are any changes while updating at that time this will use to make task detail notes
      this.loadTaskAttachment(curTask.task_id)
      this.lAction = 'update-task'
    },
    deleteTask (curTask) {
      if (!confirm('Sure, you want to delete the task with description ' + this.lTask.task_desc)) {
        return
      }
      // up in db
      this.axios.post(config.API_URL + '/task/delete', this.lTask)
      .then(response => {
        this.loadTaskStatsByCommId()
        this.loadOpenTasks(this.choosenFilter)
        this.loadTaskStats()
        this.lAction = 'view-task'
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    loadAssignToList () {
      var qry = {
        params: {
          comm_id_list: config.COMM_ID,
          vendor_id: this.showAssignedUser ? null : (config.IS_BB_VENDOR ? config.FM_VENDOR_ID : '')
        }
      }
      this.mcList = []
      this.axios.get(config.API_URL + '/getEligibleAssigneeForComplaints/', qry)
      .then(response => {
        response.data.forEach(rec => {
          this.mcList.push({user_id: rec.user_id, user_name: handy.startWithUpper(rec.cust_name), is_sv_user: rec.is_sv_user})
        })
      })
    },
    cancelChanges () {
      if (this.lAction === 'upload-bucket') {
        this.lAction = 'view-bucket'
        this.loadBucketList()
      } else {
        this.lAction = 'view-task'
      }
      this.beingSaved = false
    },
    prevMonth (curTab) {
      this.calViewPeriod.setMonth(this.calViewPeriod.getMonth() - 1)
      var curMonth = this.calViewPeriod.getMonth()
      this.calViewTitle = handy.getMonthName(curMonth) + ' ' + this.calViewPeriod.getFullYear()
      if (curTab === 0) {
        this.totPlanedTask = (this.lCalendarViewList.filter(rec => (new Date(rec.plan_end)).getMonth() === curMonth)).length
      } else {
        this.totClosedTask = (this.lCalendarViewList.filter(rec => (new Date(rec.act_end)).getMonth() === curMonth)).length
      }

      this.$refs.calendar[curTab].prev()
      this.$forceUpdate()
    },
    nextMonth (curTab) {
      this.calViewPeriod.setMonth(this.calViewPeriod.getMonth() + 1)
      var curMonth = this.calViewPeriod.getMonth()
      this.calViewTitle = handy.getMonthName(curMonth) + ' ' + this.calViewPeriod.getFullYear()
      if (curTab === 0) {
        this.totPlanedTask = (this.lCalendarViewList.filter(rec => (new Date(rec.plan_end)).getMonth() === curMonth)).length
      } else {
        this.totClosedTask = (this.lCalendarViewList.filter(rec => (new Date(rec.act_end)).getMonth() === curMonth)).length
      }
      this.$refs.calendar[curTab].next()
      this.$forceUpdate()
    },
    loadOpenTasks (curFilter) {
      this.choosenFilter = curFilter
      this.loadTaskByLater()
      .then(res => {
        this.loadTaskByDueSonner()
        .then(res => {
          this.loadTaskByPastdue()
          .then(res => {
            this.tasktabItems = this.openTaskList
            if (this.choosenView === 'card' || this.choosenView === 'list' || this.choosenView === 'calendar') {
              if (!this.action) {
                if (this.openTaskList['Past due'].length) {
                  this.selTab = 0
                } else if (this.openTaskList['Due sooner'].length) {
                  this.selTab = 1
                } else {
                  this.selTab = 2
                }
              } else {
                // show requested task if user reaches this page by clicking on a task from dashboard
                this.selTab = Number(this.action.substring(0, 1))
                this.selId = Number(this.action.substring(2))
                // focus the chosen one
                setTimeout(() => {
                  var tmpComp = document.getElementById('task_' + this.selId)
                  if (tmpComp) {
                    tmpComp.scrollIntoView({block: 'center', inline: 'nearest'})
                  }
                }, 500)
              }
            }
            this.lCalendarViewList = this.openTaskList['Past due'].concat(this.openTaskList['Due sooner']).concat(this.openTaskList['Due later'])
            this.lCalendarViewList.map(rec => { rec.plan_end = rec.plan_end ? handy.formatDBDate(rec.plan_end) : '' })
            var curMonth = this.calViewPeriod.getMonth()
            this.totPlanedTask = (this.lCalendarViewList.filter(rec => (new Date(rec.plan_end)).getMonth() === curMonth)).length
            this.totUnplanedTask = (this.lCalendarViewList.filter(rec => !rec.plan_end)).length
            this.$forceUpdate()
          })
        })
      })
      this.loadServiceCat()
    },
    loadTaskByPastdue () {
      return new Promise((resolve, reject) => {
        var qry = {
          params: {
            comm_id: config.COMM_ID,
            plan_end: handy.formatDBDate(new Date()),
            group_by: 'past_due',
            state: 'open',
            user_id: config.USER_ID,
            chip_filter: this.choosenFilter,
            filter: this.filterListByTab[this.tab]
          }
        }
        this.openTaskList['Past due'] = []
        this.axios.get(config.API_URL + '/getAllTaskByCommOrVendor/', qry)
        .then(response => {
          this.openTaskList['Past due'] = response.data
          resolve(true)
        })
        .catch(err => {
          this.msg(err, 0)
          reject(false)
        })
      })
    },
    loadTaskByDueSonner () {
      return new Promise((resolve, reject) => {
        var fromDate = new Date() // get current date
        var toDate = fromDate.getDate() + 3 // end day is the today and next 3 days
        var qry = {
          params: {
            comm_id: config.COMM_ID,
            from_dt: handy.formatDBDate(fromDate),
            to_dt: handy.formatDBDate(new Date(fromDate.setDate(toDate))),
            group_by: 'due_sooner',
            state: 'open',
            user_id: config.USER_ID,
            chip_filter: this.choosenFilter,
            filter: this.filterListByTab[this.tab]
          }
        }
        this.openTaskList['Due sooner'] = []
        this.axios.get(config.API_URL + '/getAllTaskByCommOrVendor/', qry)
        .then(response => {
          this.openTaskList['Due sooner'] = response.data
          resolve(true)
        })
        .catch(err => {
          this.msg(err, 0)
          reject(false)
        })
      })
    },
    loadTaskByLater () {
      return new Promise((resolve, reject) => {
        var current = new Date()     // get current date
        var fromDate = current.getDate() + 3 // get after 3 days date
        var qry = {
          params: {
            comm_id: config.COMM_ID,
            plan_end: handy.formatDBDate(new Date(current.setDate(fromDate))),
            group_by: 'due_later',
            state: 'open',
            user_id: config.USER_ID,
            chip_filter: this.choosenFilter,
            filter: this.filterListByTab[this.tab]
          }
        }
        this.openTaskList['Due later'] = []
        this.axios.get(config.API_URL + '/getAllTaskByCommOrVendor/', qry)
        .then(response => {
          this.openTaskList['Due later'] = response.data
          resolve(true)
        })
        .catch(err => {
          this.msg(err, 0)
          reject(false)
        })
      })
    },
    loadClosedTasks (fresh = false) {
      if (fresh) {
        this.closedTaskList['All closed'] = []
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          state: 'closed',
          rec_per_page: this.recPerPage,
          filter: this.filterListByTab[this.tab],
          choosen_view: this.choosenView,
          is_sv_user: true,
          last_act_end: (fresh || this.closedTaskList['All closed'].length === 0) ? '' : handy.formatDBDateTime(this.closedTaskList['All closed'][this.closedTaskList['All closed'].length - 1].act_end)
        }
      }
      this.axios.get(config.API_URL + '/getAllTaskByCommOrVendor/', qry)
      .then(response => {
        if (response.data.length === 0) {
          this.lastRec['all closed'] = true
        } else {
          if (this.closedTaskList['All closed'].length === 0) {
            this.closedTaskList['All closed'] = response.data
          } else if (this.choosenView === 'card') {
            this.closedTaskList['All closed'] = this.closedTaskList['All closed'].concat(response.data)
          } else {
            this.closedTaskList['All closed'] = response.data
          }
        }
        if (response.data.length < this.recPerPage) { // got only fewer than per page count
          this.lastRec['all closed'] = true
        } else {
          this.lastRec['all closed'] = false
        }
        this.lCalendarViewList = this.closedTaskList['All closed']
        this.lCalendarViewList.map(rec => { rec.act_end = rec.act_end ? handy.formatDBDate(rec.act_end) : '' })
        var curMonth = this.calViewPeriod.getMonth()
        this.totClosedTask = (this.lCalendarViewList.filter(rec => (new Date(rec.act_end)).getMonth() === curMonth)).length
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareTaskStatus (curTask, curStatus) {
      this.lTaskStatus = Object.assign({}, curTask)
      this.lTaskStatus.task_action = curStatus
      this.lTaskStatus.action_by = config.USER_ID
      this.lTaskStatus.notes = ''
      this.lTaskStatus.files = []
      this.lTaskStatus.sub_action = 'create'
      this.lTaskStatus.is_action_by_sv_user = false
      this.lTaskStatus.task_service = {comp_cat: curTask.service, comp_cat_id: curTask.task_service}
      this.lTaskStatus.task_loc_pair = {task_loc: curTask.task_loc, task_loc_id: curTask.task_loc_id}
      this.lTaskStatus.assigned_user_pair = {user_id: curTask.assigned_user_id, user_name: curTask.assigned_to, is_sv_user: curTask.is_assigned_to_sv_user}
      if (curStatus === 'Commented') {
        this.placeHolder = 'Type your comment here...'
      } else if (curStatus === 'Need More Info.') {
        this.placeHolder = 'From whom you are looking for information..'
        this.lTaskStatus.assigned_user_pair = {}
      } else if (curStatus === 'On-hold') {
        this.placeHolder = 'Type your reason for On-hold...'
      } else if (curStatus === 'Cancelled') {
        this.placeHolder = 'Type your reason for Cancel...'
      } else if (curStatus === 'Completed') {
        this.placeHolder = 'Type your resolution here...'
        this.lTaskStatus.act_end = this.today
        this.lTaskStatus.endTime = handy.getLongTime(new Date())
      } else if (curStatus === 'New' || curStatus === 'In Progress') {
        this.postTaskStatus()
      } else if (curStatus === 'Assigned') {
        this.placeHolder = 'Type your notes if any...'
        this.lTaskStatus.assigned_user_pair = {}
      } else if (curStatus === 'Pending approval') {
        this.placeHolder = 'Notes for approver if any...'
        this.lTaskStatus.assigned_user_pair = {}
      } else if (curStatus === 'Approved') {
        this.placeHolder = 'Notes for approval if any...'
      }
      if (curStatus === 'Approved' || curStatus === 'Pending approval' || curStatus === 'Assigned' || curStatus === 'Commented' || curStatus === 'Need More Info.' || curStatus === 'On-hold' || curStatus === 'Cancelled' || curStatus === 'Completed') {
        this.showDlgStatus = true
      }
      this.$forceUpdate()
    },
    postTaskStatus () {
      this.lTaskStatus.comm_id = config.COMM_ID
      if (this.lTaskStatus.sub_action === 'update') {
        this.lTaskStatus.action_by = this.lTaskStatus.created_by_user_id
      }
      if (!this.lTaskStatus.files) {
        this.lTaskStatus.files = []
      }
      if (this.lTaskStatus.act_end && this.lTaskStatus.endTime) {
        this.lTaskStatus.act_end = this.lTaskStatus.act_end + ' ' + this.lTaskStatus.endTime
      }
      if (!this.lTaskStatus.act_end || !this.lTaskStatus.endTime) {
        var date = new Date()
        this.lTaskStatus.act_end = handy.formatDBDateTime(new Date(this.today + ' ' + date.getHours() + ':' + date.getMinutes()))
      }
      if (this.lTaskStatus.assigned_user_pair && this.lTaskStatus.assigned_user_pair.user_id) {
        if (this.lTaskStatus.assigned_user_pair.is_sv_user) {
          this.lTaskStatus.is_assigned_to_sv_user = true
        } else {
          this.lTaskStatus.is_assigned_to_sv_user = false
        }
      }
      this.lTaskStatus.is_action_by_sv_user = false
      this.axios.post(config.API_URL + '/task/status', this.lTaskStatus)
      .then(response => {
        this.loadTaskStatsByCommId()
        this.loadOpenTasks(this.choosenFilter)
        this.loadTaskStats()
        this.showDlgStatus = false
        this.showTimeline = false
        this.lAction = 'view-task'
        this.tab = 'tab-0'
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
        this.showDlgStatus = false
      })
    },
    loadTimeLine (curTaskId) {
      var qry = {
        params: {
          task_id: curTaskId,
          comm_id: config.COMM_ID
        }
      }
      this.lTimeLine = {}
      this.axios.get(config.API_URL + '/getTimelineDetailsByTaskId/', qry)
      .then(response => {
        this.lTimeLine = response.data
        var timeLineNote = []
        timeLineNote = response.data.filter(rec => rec.task_action === 'Task Updated' && rec.notes !== null)
        if (timeLineNote) {
          var note = ''
          var cidx = 0
          for (var k = 0; k < timeLineNote.length; k++) {
            cidx = response.data.findIndex(rec => rec.task_det_id === timeLineNote[k].task_det_id)
            note = timeLineNote[k].notes.split(',')
            this.lTimeLine[cidx].timeLineNote = []
            for (var i = 0; i < note.length; i++) {
              this.lTimeLine[cidx].timeLineNote[i] = note[i]
            }
          }
        }
        this.loadTaskAttachment(curTaskId)
        this.showTimeline = true
        setTimeout(() => {
          var tmpItem = document.getElementById('timeline_' + (this.lTimeLine.length - 1))
          tmpItem.scrollIntoView()
        }, 100)
      })
      .catch(err => {
        this.msg(err, 0)
        this.lTimeLine = {}
        this.showTimeline = false
      })
    },
    loadTaskAttachment (curTaskId, curTaskDetId) {
      var path = require('path')
      var qry = {
        params: {
          task_id: curTaskId
        }
      }
      this.lTimeLine.fileUrls = {}
      this.axios.get(config.API_URL + '/getAttachmentByTaskId/', qry)
      .then(response => {
        this.lTimeLine.fileUrls = response.data
        // make notes if they have done any change while updating the task
        var fileUrls = this.lTimeLine.fileUrls.filter(rec => rec.task_action === 'Task created' || rec.task_action === 'Task Updated')
        if (fileUrls.length > 0) {
          this.lTask.files = []
          fileUrls.forEach((rec) => {
            this.lTask.files.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              task_action: rec.task_action,
              task_det_id: rec.task_det_id,
              task_id: rec.task_id,
              attach_timestamp: rec.attach_timestamp
            })
          })
        }
        this.lTimeLine.attachImages = []
        this.lTimeLine.attachFile = []
        this.lTimeLine.fileUrls.forEach(rec => {
          rec.extension = rec.file_url.split('.')[1]
          if (rec.extension.toLowerCase() === 'png' || rec.extension.toLowerCase() === 'jpg' || rec.extension.toLowerCase() === 'gif') {
            this.lTimeLine.attachImages.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              task_action: rec.task_action,
              task_det_id: rec.task_det_id,
              task_id: rec.task_id,
              attach_timestamp: rec.attach_timestamp
            })
          } else {
            this.lTimeLine.attachFile.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              task_action: rec.task_action,
              task_det_id: rec.task_det_id,
              task_id: rec.task_id,
              attach_timestamp: rec.attach_timestamp
            })
          }
        })
        // show images in status if user have attached any
        if (this.showDlgStatus) {
          var files = this.lTimeLine.fileUrls.filter(rec => rec.task_det_id === curTaskDetId)
          if (files.length > 0) {
            this.lTaskStatus.files = []
            files.forEach((rec) => {
              this.lTaskStatus.files.push({
                file_url: rec.file_url,
                file_name: rec.file_url ? path.basename(rec.file_url) : '',
                is_selected: true,
                is_changed: false,
                task_action: rec.task_action,
                task_det_id: rec.task_det_id,
                task_id: rec.task_id,
                attach_timestamp: rec.attach_timestamp
              })
            })
          }
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
        this.lTimeLine.fileUrls = []
      })
    },
    loadMoreClosed ($state) {
      // load more into current tab
      this.load = true
      setTimeout(() => {
        this.loadClosedTasks()
        setTimeout(() => {
          $state.loaded()
          if (this.lastRec['all closed']) {
            $state.complete()
          }
          this.$forceUpdate()
          this.load = false
        }, 100)
      }, 500)
    },
    prepareUpdateComment (curComment) {
      this.lTaskStatus = Object.assign({}, curComment) // keep the original object safely before changes
      this.lTaskStatus.sub_action = 'update'
      this.loadTaskAttachment(curComment.task_id, curComment.task_det_id)
      this.showDlgStatus = true
    },
    deleteComment (curComment) {
      if (!confirm('Sure, you want to delete the task with description "' + curComment.notes + '"')) {
        return
      }
      this.axios.post(config.API_URL + '/task/deleteComment', curComment)
      .then(response => {
        this.loadTaskStatsByCommId()
        this.loadOpenTasks(this.choosenFilter)
        this.loadTaskStats()
        this.loadTimeLine(curComment.task_id)
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadTaskStatsByCommId () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID,
          filter: this.filterListByTab[this.tab]
        }
      }
      this.axios.get(config.API_URL + '/getTaskStatsByCommOrVendor/', qry)
      .then(response => {
        this.filterStats = response.data
      })
      .catch(err => {
        this.msg(err, 0)
        this.filterStats = []
      })
    },
    prepareFilter () {
      this.showFilter = true
      this.loadProjectName()
    },
    getEmptyFilter () {
      var filter = {
        from_dt: null,
        to_dt: null,
        comm_id_list: [],
        created_user_pair_list: [],
        assigned_user_pair_list: [],
        task_service_list: [],
        task_cat_list: [],
        task_loc_list: [],
        priority_list: [],
        task_status_list: [],
        proj_name_list: []
      }
      return filter
    },
    clearFilter () {
      this.filterListByTab[this.tab].from_dt = null
      this.filterListByTab[this.tab].to_dt = null
      this.filterListByTab[this.tab].created_user_pair_list = []
      this.filterListByTab[this.tab].assigned_user_pair_list = []
      this.filterListByTab[this.tab].task_service_list = []
      this.filterListByTab[this.tab].task_cat_list = []
      this.filterListByTab[this.tab].task_loc_list = []
      this.filterListByTab[this.tab].priority_list = []
      this.filterListByTab[this.tab].task_status_list = []
      this.filterListByTab[this.tab].proj_name_list = []
      if (this.tab === 'tab-0') {
        this.loadOpenTasks(this.choosenFilter)
        this.loadTaskStatsByCommId()
      } else {
        this.loadClosedTasks(true)
        this.tasktabItems = this.closedTaskList
      }
      this.enabledFilter[this.tab] = false
      this.showFilter = false
      this.$forceUpdate()
    },
    loadProjectName () {
      var qry = {
        params: {
          comm_id_list: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getTaskProjectNameList/', qry)
      .then(response => {
        this.projName = response.data.map(rec => rec.proj_name)
      })
      .catch(err => {
        this.msg(err, 0)
        this.projName = []
      })
    },
    applyFilter () {
      if (this.filterListByTab[this.tab].from_dt > this.filterListByTab[this.tab].to_dt) {
        this.msg('to date should be greater than from date')
      } else {
        if (!this.filterListByTab[this.tab].from_dt && this.filterListByTab[this.tab].to_dt) {
          this.filterListByTab[this.tab].from_dt = this.filterListByTab[this.tab].to_dt
        } else if (this.filterListByTab[this.tab].from_dt && !this.filterListByTab[this.tab].to_dt) {
          this.filterListByTab[this.tab].to_dt = this.filterListByTab[this.tab].from_dt
        }
        if (this.filterListByTab[this.tab].assigned_user_pair_list.user_id || this.filterListByTab[this.tab].created_user_pair_list.user_id || this.filterListByTab[this.tab].priority_list.length || this.filterListByTab[this.tab].proj_name_list.length || this.filterListByTab[this.tab].task_cat_list.length || this.filterListByTab[this.tab].task_loc_list.length || this.filterListByTab[this.tab].task_service_list.length || this.filterListByTab[this.tab].task_status_list.length || this.filterListByTab[this.tab].from_dt || this.filterListByTab[this.tab].to_dt) {
          this.enabledFilter[this.tab] = true
        }
        if (this.tab === 'tab-0') {
          this.loadOpenTasks(this.choosenFilter)
          this.loadTaskStatsByCommId()
        } else {
          this.loadClosedTasks(true)
          this.tasktabItems = this.closedTaskList
        }
        this.showFilter = false
        this.$forceUpdate()
      }
    },
    loadTaskForDownload () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getTaskForDownload/', qry)
      .then(response => {
        this.taskItems = response.data
        this.taskItems.forEach(rec => {
          rec.plan_end = rec.plan_end ? handy.formatDate(rec.plan_end) : null
        })
      })
      .catch(err => {
        this.msg(err, 0)
        this.taskItems = []
      })
    },
    prepareUpload () {
      if (this.lAction !== 'view-bucket') {
        this.lAction = 'upload-task'
      } else {
        this.lAction = 'upload-bucket'
        this.lBucket.task_bucket_name = ''
        this.lBucket.task_bucket_id = null
        this.loadBucketList()
      }
    },
    promptUpload () {
      if (this.lAction === 'upload-task') {
        this.$refs.ipFile.click()
        this.lBucket = {}
      } else {
        if (this.lBucket.task_bucket_name || this.lBucket.task_bucket_id) {
          this.$refs.ipFile.click()
        } else {
          this.msg('please provide the details in step 4')
        }
      }
    },
    validateFile () {
      this.lAction = 'validate'
      this.validateInProgress = true
      this.loadInProgress = true
      this.validFile = true
      this.headerIssue = false
      this.fileError = false
      this.totRecs = 0
      this.recsLoaded = []
      this.totValid = 0
      this.totInvalid = 0
      this.totLoaded = 0
      this.totFail = 0

      // read file
      var file = this.$refs.ipFile.files[0]
      var tmpHeader = []
      var tmpColumnNames = []
      var reader = new FileReader()
      reader.onload = (e) => {
        var content = e.target.result

        // validate & show result
        var allLines = content.split(/\r\n/)
        // ignore empty lines if any
        allLines = allLines.filter(rec => !rec.startsWith(',,,,'))
        this.totRecs = allLines.length - 1
        var headers = allLines[0].split(',')
        // 1. header & required columns
        if (this.lBucket.task_bucket_name || this.lBucket.task_bucket_id) {
          tmpHeader = this.reqHeadersBucket
          tmpColumnNames = this.colNamesBucket
        } else {
          tmpHeader = this.reqHeaders
          tmpColumnNames = this.colNames
        }
        for (var i = 0; i < tmpHeader.length; i++) {
          if (headers[i] !== tmpHeader[i]) {
            this.validateInProgress = false
            this.validFile = false
            this.headerIssue = true
            return
          }
        }
        // 2. validate each record
        var res = {}
        var curRec = []
        for (var j = 1; j < allLines.length; j++) {
          if (allLines[j]) {
            curRec = allLines[j].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
            res = {'error': ''}
            for (var c = 0; c < tmpColumnNames.length; c++) {
              if (tmpColumnNames[c].is_required && curRec[c].trim() === '') {
                // special validation
                if (tmpColumnNames[c].col_name === 'proj_name' || tmpColumnNames[c].col_name === 'service') {
                  if (tmpColumnNames[c].col_name === 'proj_name' && res['task_cat'] === 'Project') {
                    res['error'] += tmpHeader[c] + ' is empty; '
                  } else if (tmpColumnNames[c].col_name === 'service' && res['task_cat'] !== 'Project') {
                    res['error'] += tmpHeader[c] + ' is empty; '
                  }
                } else {
                  res['error'] += tmpHeader[c] + ' is empty; '
                }
              }
              if (res['assigned_to'] === '') {
                res['assigned_to'] = null
              }
              if (res['task_cat'] !== 'Project') {
                res['proj_name'] = ''
              } else {
                res['service'] = ''
              }
              // special handling
              if (tmpColumnNames[c].col_name === 'check_list' && curRec[c]) {
                res['cl_item_list'] = curRec[c].split('\n')
              }
              res[tmpColumnNames[c].col_name] = curRec[c] && curRec[c].indexOf('"') >= 0 ? curRec[c].split('"').join('') : curRec[c]
            }
            this.recsLoaded.push(res)
            if (res['error']) {
              this.totInvalid++
            } else {
              this.totValid++
            }
          }
        }
        if (this.totInvalid) {
          this.validFile = false
        }
        this.validateInProgress = false
      }
      reader.readAsText(file)
    },
    cancelValidation () {
      if (this.lBucket.task_bucket_name || this.lBucket.task_bucket_id) {
        this.lAction = 'upload-bucket'
      } else {
        this.lAction = 'upload-task'
      }
    },
    showError (err) {
      this.msg(err, 2)
    },
    async uploadTask () {
      // create task records one by one
      this.readyForLoad = true
      this.loadInProgress = true
      this.beingSaved = true
      var curRec = {}
      var apiName = ''
      var tmpDt = null
      curRec.comm_id = config.COMM_ID
      curRec.created_user_id = config.USER_ID
      curRec.is_action_by_sv_user = false
      curRec.is_created_by_sv_user = false
      curRec.cl_created_by = config.CUST_NAME + ' [' + config.ROLE_NAME + ']'
      if (this.bucketType === 'new' && this.lBucket.task_bucket_name) {
        curRec.task_bucket_name = this.lBucket.task_bucket_name
        curRec.sub_action = 'new-bucket'
      } else if (this.bucketType === 'existing' && this.lBucket.task_bucket_id) {
        curRec.task_bucket_id = this.lBucket.task_bucket_id
        curRec.sub_action = 'update-bucket'
        curRec.last_updated_by_user_id = config.USER_ID
      } else {
        curRec.sub_action = 'upload-task'
      }
      for (var i = 0; i < this.recsLoaded.length; i++) {
        curRec.detail = this.recsLoaded[i]
        curRec.first_record = i === 0
        if (!curRec.detail.error) { // process only valid records
          // fill-in gaps
          if (curRec.detail.plan_start) {
            tmpDt = curRec.detail.plan_start.split('/')
            curRec.detail.plan_start = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
          } else {
            curRec.detail.plan_start = null
          }

          if (curRec.detail.plan_end) {
            tmpDt = curRec.detail.plan_end.split('/')
            curRec.detail.plan_end = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
          } else {
            curRec.detail.plan_end = null
          }

          if (curRec.detail.task_status === 'Completed') {
            if (curRec.detail.act_end) {
              tmpDt = curRec.detail.act_end.split('/')
              curRec.detail.act_end = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
            } else {
              curRec.detail.act_end = handy.formatDBDate(new Date())
            }
          } else {
            if (curRec.detail.act_end) {
              tmpDt = curRec.detail.act_end.split('/')
              curRec.detail.act_end = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
            } else {
              curRec.detail.act_end = null
            }
          }

          if (curRec.detail.act_start) {
            tmpDt = curRec.detail.act_start.split('/')
            curRec.detail.act_start = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
          } else {
            curRec.detail.act_start = null
          }

          if (!curRec.detail.cl_item_list) {
            curRec.detail.cl_item_list = []
          }

          // upload current record
          if (curRec.sub_action === 'upload-task') {
            apiName = '/taskUpload/'
          } else {
            apiName = '/taskBucketUpload/'
          }
          await this.axios.post(config.API_URL + apiName, curRec)
          .then(response => {
            curRec.detail.load_status = 'Loaded'
            this.totLoaded++
            if (curRec.sub_action === 'new-bucket' && !curRec.task_bucket_id) {
              curRec.task_bucket_id = response.data
            }
          })
          .catch(err => {
            curRec.detail.error = err.response.data
            curRec.detail.load_status = 'Failed'
            this.totFail++
          })
          this.$forceUpdate()
        }
      } // for every record
      if (this.totLoaded) {
        if (curRec.sub_action === 'upload-task') {
          this.loadTaskStatsByCommId()
          this.loadOpenTasks('Created By Me')
          this.loadTaskStats()
          if (!this.totFail) {
            this.lAction = 'view-task'
          }
        } else {
          this.loadBucketList()
          if (!this.totFail) {
            this.lAction = 'view-bucket'
          }
        }
      }
      this.$forceUpdate()
      this.loadInProgress = false
      this.beingSaved = false
    },
    prepareCategory () {
      this.manageTaskCat = true
      this.lMAction = 'view'
    },
    loadTaskCategory () {
      var qry = {
        params: {
          comm_id_list: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getTaskCategoryByCommId/', qry)
      .then(response => {
        this.catList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
        this.catList = []
      })
    },
    prepareLoc () {
      this.manageTaskLoc = true
      this.lLAction = 'view'
    },
    loadTaskLocation () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getTaskLocationByCommId/', qry)
      .then(response => {
        this.locList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
        this.locList = []
      })
    },
    createManageTask () {
      this.lCat = {
        comm_id: config.COMM_ID,
        task_cat: ''
      }
      this.lMAction = 'create'
    },
    cancelChangesCat () {
      this.lMAction = 'view'
    },
    saveTaskCat () {
      // validate and save Changes
      if (this.$refs.acForm.validate()) {
        this.beingSaved = true
        this.axios.post(config.API_URL + '/taskCat/' + this.lMAction, this.lCat)
        .then(response => {
          // refresh the Category list
          this.loadTaskCategory()
          this.lMAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    prepareEdit (curCat) {
      this.lCat = Object.assign({}, curCat) // keep the original object safely before changes
      this.lMAction = 'update'
    },
    deleteCat (curCat) {
      if (!confirm('Sure, you want to delete the Category "' + curCat.task_cat + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/taskCat/delete', curCat)
      .then(response => {
        // refresh the task category list
        this.loadTaskCategory()
        this.lMAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    createManageLoc () {
      this.lLoc = {
        comm_id: config.COMM_ID,
        task_loc: ''
      }
      this.lLAction = 'create'
    },
    cancelChangesLoc () {
      this.lLAction = 'view'
    },
    saveTaskLoc () {
      // validate and save Changes
      if (this.$refs.acForm.validate()) {
        this.beingSaved = true
        this.axios.post(config.API_URL + '/taskLoc/' + this.lLAction, this.lLoc)
        .then(response => {
          // refresh the Category list
          this.loadTaskLocation()
          this.lLAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    prepareEditLoc (curLoc) {
      this.lLoc = Object.assign({}, curLoc) // keep the original object safely before changes
      this.lLAction = 'update'
    },
    deleteLoc (curLoc) {
      if (!confirm('Sure, you want to delete the location "' + curLoc.task_loc + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/taskLoc/delete', curLoc)
      .then(response => {
        // refresh the task category list
        this.loadTaskLocation()
        this.lLAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    prepareBucket () {
      this.lAction = 'view-bucket'
      this.loadBucketList()
    },
    loadBucketList () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getBucketListByCommOrVendor/', qry)
      .then(response => {
        this.bucketList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
        this.bucketList = []
      })
    },
    prepareImportBucket (curBucket) {
      var qry = {
        params: {
          task_bucket_id: curBucket.task_bucket_id,
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getBucketDetailsById/', qry)
      .then(response => {
        this.bucketImportList = response.data
        this.showImportBucketList = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.bucketImportList = []
        this.showImportBucketList = false
      })
    },
    async importToTask () {
      for (var i = 0; i < this.selected.length; i++) {
        this.selected[i].comm_id = config.COMM_ID
        this.selected[i].created_user_id = config.USER_ID
        this.selected[i].files = []
        this.selected[i].assigned_user_pair = {}
        await this.axios.post(config.API_URL + '/task/create-task', this.selected[i])
      }
      this.loadTaskStatsByCommId()
      this.loadOpenTasks(this.choosenFilter)
      this.loadTaskStats()
      this.lAction = 'view-task'
      this.showImportBucketList = false
    },
    prepareUpdateTaskInBucket (curList) {
      this.lImportList = Object.assign({}, curList) // keep the original object safely before changes
      this.lImportList.task_cat_pair = {task_cat: this.lImportList.task_cat, task_cat_id: this.lImportList.task_cat_id}
      this.showEditBucket = true
    },
    findCat (curTask) {
      if (curTask.task_cat_pair) {
        curTask.task_cat_id = curTask.task_cat_pair.task_cat_id
        curTask.task_cat = curTask.task_cat_pair.task_cat
      }
    },
    saveUpdatedTask () {
      this.axios.post(config.API_URL + '/updateTaskFromBucket/update', this.lImportList)
      .then(response => {
        this.prepareImportBucket(this.lImportList)
        this.lAction = 'view-bucket'
        this.showEditBucket = false
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    deleteTaskInBucket (curTask) {
      if (!confirm('Sure, you want to delete the task "' + curTask.task_desc + '"?')) {
        return
      }
      this.axios.post(config.API_URL + '/updateTaskFromBucket/delete', curTask)
      .then(response => {
        this.prepareImportBucket(curTask)
        this.lAction = 'view-bucket'
        this.showEditBucket = false
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    LoadAssignedUserDetails () {
      this.showAssignedUser = true
      this.loadAssignToList()
    },
    changeView (curView) {
      this.choosenView = curView
      if (this.tab === 'tab-1') {
        this.loadClosedTasks()
      }
    },
    prepareChecklist (curTask) {
      this.lCl = Object.assign({}, curTask)
      this.showCheckList = true
      this.loadCheckList(curTask.task_id)
    },
    loadCheckList (curTaskId) {
      this.taskId = curTaskId
      var qry = {
        params: {
          task_id: curTaskId
        }
      }
      this.clDownloadList = []
      this.axios.get(config.API_URL + '/getChecklistByTaskId/', qry)
      .then(response => {
        this.clList = response.data
        this.clList.forEach(rec => {
          if (rec.is_cl_completed) {
            rec.is_cl_completed = true
          } else {
            rec.is_cl_completed = false
          }
          this.clDownloadList.push({
            cl_item: rec.cl_item,
            status: rec.is_cl_completed ? 'Completed' : 'Incomplete'
          })
        })
      })
      .catch(err => {
        this.msg(err, 0)
        this.clList = []
      })
    },
    prepareCreateCl () {
      this.lChecklist = Object.assign({}, this.clList)
      this.lChecklist.task_id = this.taskId
      this.lChecklist.cl_item = ''
      this.lChecklist.cl_created_by = config.CUST_NAME + ' [' + config.ROLE_NAME + ']'
      this.lChecklist.lAction = 'create'
      this.showCl = true
    },
    saveClChanges () {
      if (!this.$refs.clForm.validate()) {
        return
      }
      if (this.lChecklist.lAction === 'update') {
        this.lChecklist.cl_last_updated_by = config.CUST_NAME + ' [' + config.ROLE_NAME + ']'
      }
      this.axios.post(config.API_URL + '/taskChecklist/' + this.lChecklist.lAction, this.lChecklist)
      .then(response => {
        this.loadCheckList(this.lChecklist.task_id)
        if (this.lChecklist.lAction === 'create') {
          this.lCl.task_id = this.lChecklist.task_id
          this.lCl.tot_cl++
          if (this.tab === 'tab-0') {
            for (var i = 0; i < this.subOpenTabItems.length; i++) {
              if (this.openTaskList[this.subOpenTabItems[i]].length > 0) {
                var idx = this.openTaskList[this.subOpenTabItems[i]].findIndex(rec => rec.task_id === this.lCl.task_id)
                Object.assign(this.openTaskList[this.subOpenTabItems[i]][idx], this.lCl)
              }
            }
          }
        }
        this.showCl = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    prepareUpdateChecklist (curTaskCl) {
      this.lChecklist = Object.assign({}, curTaskCl)
      this.lChecklist.lAction = 'update'
      this.showCl = true
    },
    deleteTaskChecklist (curTaskCl) {
      if (!confirm('Sure, you want to delete checklist with item name "' + curTaskCl.cl_item + '"?')) {
        return
      }
      this.axios.post(config.API_URL + '/taskChecklist/delete', curTaskCl)
      .then(response => {
        this.lCl.task_id = curTaskCl.task_id
        this.loadCheckList(curTaskCl.task_id)
        this.lCl.tot_cl--
        if (this.tab === 'tab-0') {
          for (var i = 0; i < this.subOpenTabItems.length; i++) {
            if (this.openTaskList[this.subOpenTabItems[i]].length > 0) {
              var idx = this.openTaskList[this.subOpenTabItems[i]].findIndex(rec => rec.task_id === this.lCl.task_id)
              Object.assign(this.openTaskList[this.subOpenTabItems[i]][idx], this.lCl)
            }
          }
        }
        this.showCl = false
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    saveTaskClChanges (curTaskCl) {
      if (curTaskCl.is_cl_completed) {
        this.lCl.tot_completed_cl++
      } else {
        this.lCl.tot_completed_cl--
      }
      if (this.tab === 'tab-0') {
        for (var i = 0; i < this.subOpenTabItems.length; i++) {
          if (this.openTaskList[this.subOpenTabItems[i]].length > 0) {
            var idx = this.openTaskList[this.subOpenTabItems[i]].findIndex(rec => rec.task_id === this.lCl.task_id)
            if (idx > -1) {
              Object.assign(this.openTaskList[this.subOpenTabItems[i]][idx], this.lCl)
            }
          }
        }
      }
      this.lChecklist = Object.assign({}, curTaskCl)
      this.lChecklist.lAction = 'update'
      this.saveClChanges()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Task.vue?752db0c6